
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8cf7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8cf7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $9fbe9702d0a13179$exports = {};
$parcel$extendImportMap({
    "hhnHs": "stanley.0d296530.png"
});


var $a0b4f895e1596b3b$exports = {};
!function(e) {
    "use strict";
    function n(e, n, t) {
        return t.a = e, t.f = n, t;
    }
    function F2(e) {
        return n(2, e, function(n) {
            return function(t) {
                return e(n, t);
            };
        });
    }
    function F3(e) {
        return n(3, e, function(n) {
            return function(t) {
                return function(r) {
                    return e(n, t, r);
                };
            };
        });
    }
    function F4(e) {
        return n(4, e, function(n) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return e(n, t, r, a);
                    };
                };
            };
        });
    }
    function F5(e) {
        return n(5, e, function(n) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return e(n, t, r, a, i);
                        };
                    };
                };
            };
        });
    }
    function F6(e) {
        return n(6, e, function(n) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return e(n, t, r, a, i, u);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(e) {
        return n(7, e, function(n) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(o) {
                                    return e(n, t, r, a, i, u, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(e, n, t) {
        return 2 === e.a ? e.f(n, t) : e(n)(t);
    }
    function A3(e, n, t, r) {
        return 3 === e.a ? e.f(n, t, r) : e(n)(t)(r);
    }
    function A4(e, n, t, r, a) {
        return 4 === e.a ? e.f(n, t, r, a) : e(n)(t)(r)(a);
    }
    function A5(e, n, t, r, a, i) {
        return 5 === e.a ? e.f(n, t, r, a, i) : e(n)(t)(r)(a)(i);
    }
    function A6(e, n, t, r, a, i, u) {
        return 6 === e.a ? e.f(n, t, r, a, i, u) : e(n)(t)(r)(a)(i)(u);
    }
    function A7(e, n, t, r, a, i, u, o) {
        return 7 === e.a ? e.f(n, t, r, a, i, u, o) : e(n)(t)(r)(a)(i)(u)(o);
    }
    var t = F3(function(e, n, t) {
        for(var r = Array(e), a = 0; e > a; a++)r[a] = t(n + a);
        return r;
    }), r = F2(function(e, n) {
        for(var t = Array(e), r = 0; e > r && n.b; r++)t[r] = n.a, n = n.b;
        return t.length = r, l(t, n);
    });
    function a(e) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + e + ".md");
    }
    function i(e, n) {
        for(var t, r = [], a = u(e, n, 0, r); a && (t = r.pop()); a = u(t.a, t.b, 0, r));
        return a;
    }
    function u(e, n, t, r) {
        if (e === n) return !0;
        if ("object" != typeof e || null === e || null === n) return "function" == typeof e && a(5), !1;
        if (t > 100) return r.push(l(e, n)), !0;
        for(var i in 0 > e.$ && (e = An(e), n = An(n)), e)if (!u(e[i], n[i], t + 1, r)) return !1;
        return !0;
    }
    var o = F2(i), c = F2(function(e, n) {
        return !i(e, n);
    });
    function s(e, n, t) {
        if ("object" != typeof e) return e === n ? 0 : n > e ? -1 : 1;
        if (void 0 === e.$) return (t = s(e.a, n.a)) || (t = s(e.b, n.b)) ? t : s(e.c, n.c);
        for(; e.b && n.b && !(t = s(e.a, n.a)); e = e.b, n = n.b);
        return t || (e.b ? 1 : n.b ? -1 : 0);
    }
    var f = F2(function(e, n) {
        var t = s(e, n);
        return 0 > t ? Ln : t ? Tn : Sn;
    });
    function l(e, n) {
        return {
            a: e,
            b: n
        };
    }
    function h(e, n, t) {
        return {
            a: e,
            b: n,
            c: t
        };
    }
    function b(e) {
        return e;
    }
    function p(e, n) {
        var t = {};
        for(var r in e)t[r] = e[r];
        for(var r in n)t[r] = n[r];
        return t;
    }
    function d(e, n) {
        if ("string" == typeof e) return e + n;
        if (!e.b) return n;
        var t = v(e.a, n);
        e = e.b;
        for(var r = t; e.b; e = e.b)r = r.b = v(e.a, n);
        return t;
    }
    var g = {
        $: 0
    };
    function v(e, n) {
        return {
            $: 1,
            a: e,
            b: n
        };
    }
    var m = F2(v);
    function $(e) {
        for(var n = g, t = e.length; t--;)n = v(e[t], n);
        return n;
    }
    var y = F3(function(e, n, t) {
        for(var r = []; n.b && t.b; n = n.b, t = t.b)r.push(A2(e, n.a, t.a));
        return $(r);
    }), w = F2(function(e, n) {
        var t = n % e;
        return 0 === e ? a(11) : t > 0 && 0 > e || 0 > t && e > 0 ? t + e : t;
    }), k = Math.ceil, x = Math.floor, _ = Math.log, j = F2(function(e, n) {
        return n.split(e);
    }), z = F2(function(e, n) {
        return n.join(e);
    }), A = F3(function(e, n, t) {
        return t.slice(e, n);
    }), S = F2(function(e, n) {
        for(var t = n.length; t--;){
            var r = n[t], a = n.charCodeAt(t);
            if (56320 > a || a > 57343 || (r = n[--t] + r), !e(b(r))) return !1;
        }
        return !0;
    }), T = F2(function(e, n) {
        return 0 === n.indexOf(e);
    });
    function L(e) {
        return {
            $: 2,
            b: e
        };
    }
    var N = L(function(e) {
        return "number" != typeof e ? G("an INT", e) : e > -2147483647 && 2147483647 > e && (0 | e) === e ? On(e) : !isFinite(e) || e % 1 ? G("an INT", e) : On(e);
    }), C = L(function(e) {
        return "boolean" == typeof e ? On(e) : G("a BOOL", e);
    }), E = (L(function(e) {
        return "number" == typeof e ? On(e) : G("a FLOAT", e);
    }), L(function(e) {
        return On(e);
    })), q = L(function(e) {
        return "string" == typeof e ? On(e) : e instanceof String ? On(e + "") : G("a STRING", e);
    }), O = F2(function(e, n) {
        return {
            $: 6,
            d: e,
            b: n
        };
    });
    function I(e, n) {
        return {
            $: 9,
            f: e,
            g: n
        };
    }
    var P = F2(function(e, n) {
        return {
            $: 10,
            b: n,
            h: e
        };
    }), R = F2(function(e, n) {
        return I(e, [
            n
        ]);
    }), X = F3(function(e, n, t) {
        return I(e, [
            n,
            t
        ]);
    }), F = F2(function(e, n) {
        try {
            return D(e, JSON.parse(n));
        } catch (e) {
            return Nn(A2(Cn, "This is not valid JSON! " + e.message, n));
        }
    }), J = F2(function(e, n) {
        return D(e, n);
    });
    function D(e, n) {
        switch(e.$){
            case 2:
                return e.b(n);
            case 5:
                return null === n ? On(e.c) : G("null", n);
            case 3:
                return K(n) ? U(e.b, n, $) : G("a LIST", n);
            case 4:
                return K(n) ? U(e.b, n, B) : G("an ARRAY", n);
            case 6:
                var t = e.d;
                if ("object" != typeof n || null === n || !(t in n)) return G("an OBJECT with a field named `" + t + "`", n);
                var r = D(e.b, n[t]);
                return At(r) ? r : Nn(A2(En, t, r.a));
            case 7:
                var a = e.e;
                return K(n) ? n.length > a ? (r = D(e.b, n[a]), At(r) ? r : Nn(A2(qn, a, r.a))) : G("a LONGER array. Need index " + a + " but only see " + n.length + " entries", n) : G("an ARRAY", n);
            case 8:
                if ("object" != typeof n || null === n || K(n)) return G("an OBJECT", n);
                var i = g;
                for(var u in n)if (n.hasOwnProperty(u)) {
                    if (r = D(e.b, n[u]), !At(r)) return Nn(A2(En, u, r.a));
                    i = v(l(u, r.a), i);
                }
                return On(nt(i));
            case 9:
                for(var o = e.f, c = e.g, s = 0; c.length > s; s++){
                    if (r = D(c[s], n), !At(r)) return r;
                    o = o(r.a);
                }
                return On(o);
            case 10:
                return r = D(e.b, n), At(r) ? D(e.h(r.a), n) : r;
            case 11:
                for(var f = g, h = e.g; h.b; h = h.b){
                    if (r = D(h.a, n), At(r)) return r;
                    f = v(r.a, f);
                }
                return Nn(In(nt(f)));
            case 1:
                return Nn(A2(Cn, e.a, n));
            case 0:
                return On(e.a);
        }
    }
    function U(e, n, t) {
        for(var r = n.length, a = Array(r), i = 0; r > i; i++){
            var u = D(e, n[i]);
            if (!At(u)) return Nn(A2(qn, i, u.a));
            a[i] = u.a;
        }
        return On(t(a));
    }
    function K(e) {
        return Array.isArray(e) || "undefined" != typeof FileList && e instanceof FileList;
    }
    function B(e) {
        return A2(zt, e.length, function(n) {
            return e[n];
        });
    }
    function G(e, n) {
        return Nn(A2(Cn, "Expecting " + e, n));
    }
    function H(e, n) {
        if (e === n) return !0;
        if (e.$ !== n.$) return !1;
        switch(e.$){
            case 0:
            case 1:
                return e.a === n.a;
            case 2:
                return e.b === n.b;
            case 5:
                return e.c === n.c;
            case 3:
            case 4:
            case 8:
                return H(e.b, n.b);
            case 6:
                return e.d === n.d && H(e.b, n.b);
            case 7:
                return e.e === n.e && H(e.b, n.b);
            case 9:
                return e.f === n.f && M(e.g, n.g);
            case 10:
                return e.h === n.h && H(e.b, n.b);
            case 11:
                return M(e.g, n.g);
        }
    }
    function M(e, n) {
        var t = e.length;
        if (t !== n.length) return !1;
        for(var r = 0; t > r; r++)if (!H(e[r], n[r])) return !1;
        return !0;
    }
    var W = F2(function(e, n) {
        return JSON.stringify(n, null, e) + "";
    });
    function Y(e) {
        return e;
    }
    function Q(e) {
        return e;
    }
    var V = F3(function(e, n, t) {
        return t[e] = n, t;
    });
    function Z(e) {
        return {
            $: 0,
            a: e
        };
    }
    function ee(e) {
        return {
            $: 1,
            a: e
        };
    }
    function ne(e) {
        return {
            $: 2,
            b: e,
            c: null
        };
    }
    var te = F2(function(e, n) {
        return {
            $: 3,
            b: e,
            d: n
        };
    }), re = F2(function(e, n) {
        return {
            $: 4,
            b: e,
            d: n
        };
    }), ae = 0;
    function ie(e) {
        var n = {
            $: 0,
            e: ae++,
            f: e,
            g: null,
            h: []
        };
        return le(n), n;
    }
    function ue(e) {
        return ne(function(n) {
            n(Z(ie(e)));
        });
    }
    function oe(e, n) {
        e.h.push(n), le(e);
    }
    var ce = F2(function(e, n) {
        return ne(function(t) {
            oe(e, n), t(Z(0));
        });
    }), se = !1, fe = [];
    function le(e) {
        if (fe.push(e), !se) {
            for(se = !0; e = fe.shift();)he(e);
            se = !1;
        }
    }
    function he(e) {
        for(; e.f;){
            var n = e.f.$;
            if (0 === n || 1 === n) {
                for(; e.g && e.g.$ !== n;)e.g = e.g.i;
                if (!e.g) return;
                e.f = e.g.b(e.f.a), e.g = e.g.i;
            } else {
                if (2 === n) return void (e.f.c = e.f.b(function(n) {
                    e.f = n, le(e);
                }));
                if (5 === n) {
                    if (0 === e.h.length) return;
                    e.f = e.f.b(e.h.shift());
                } else e.g = {
                    $: 3 === n ? 0 : 1,
                    b: e.f.b,
                    i: e.g
                }, e.f = e.f.d;
            }
        }
    }
    var be = {};
    function pe(e, n, t, r, a) {
        return {
            b: e,
            c: n,
            d: t,
            e: r,
            f: a
        };
    }
    function de(e, n) {
        var t = {
            g: n,
            h: void 0
        }, r = e.c, a = e.d, i = e.e, u = e.f;
        function o(e) {
            return A2(te, o, {
                $: 5,
                b: function(n) {
                    var o = n.a;
                    return 0 === n.$ ? A3(a, t, o, e) : i && u ? A4(r, t, o.i, o.j, e) : A3(r, t, i ? o.i : o.j, e);
                }
            });
        }
        return t.h = ie(A2(te, o, e.b));
    }
    var ge = F2(function(e, n) {
        return ne(function(t) {
            e.g(n), t(Z(0));
        });
    }), ve = F2(function(e, n) {
        return A2(ce, e.h, {
            $: 0,
            a: n
        });
    });
    function me(e) {
        return function(n) {
            return {
                $: 1,
                k: e,
                l: n
            };
        };
    }
    function $e(e) {
        return {
            $: 2,
            m: e
        };
    }
    var ye = [], we = !1;
    function ke(e, n, t) {
        if (ye.push({
            p: e,
            q: n,
            r: t
        }), !we) {
            we = !0;
            for(var r; r = ye.shift();)xe(r.p, r.q, r.r);
            we = !1;
        }
    }
    function xe(e, n, t) {
        var r = {};
        for(var a in _e(!0, n, r, null), _e(!1, t, r, null), e)oe(e[a], {
            $: "fx",
            a: r[a] || {
                i: g,
                j: g
            }
        });
    }
    function _e(e, n, t, r) {
        switch(n.$){
            case 1:
                var a = n.k, i = function(e, n, t, r) {
                    function a(e) {
                        for(var n = t; n; n = n.t)e = n.s(e);
                        return e;
                    }
                    return A2(e ? be[n].e : be[n].f, a, r);
                }(e, a, r, n.l);
                return void (t[a] = function(e, n, t) {
                    return t = t || {
                        i: g,
                        j: g
                    }, e ? t.i = v(n, t.i) : t.j = v(n, t.j), t;
                }(e, i, t[a]));
            case 2:
                for(var u = n.m; u.b; u = u.b)_e(e, u.a, t, r);
                return;
            case 3:
                return void _e(e, n.o, t, {
                    s: n.n,
                    t: r
                });
        }
    }
    function je(e) {
        be[e] && a(3);
    }
    function ze(e, n) {
        return je(e), be[e] = {
            e: Ae,
            u: n,
            a: Se
        }, me(e);
    }
    var Ae = F2(function(e, n) {
        return n;
    });
    function Se(e) {
        var n = [], t = be[e].u, r = ne(function(e) {
            var n = setTimeout(function() {
                e(Z(0));
            }, 0);
            return function() {
                clearTimeout(n);
            };
        });
        return be[e].b = r, be[e].c = F3(function(e, a) {
            for(; a.b; a = a.b)for(var i = n, u = Q(t(a.a)), o = 0; i.length > o; o++)i[o](u);
            return r;
        }), {
            subscribe: function(e) {
                n.push(e);
            },
            unsubscribe: function(e) {
                var t = (n = n.slice()).indexOf(e);
                0 > t || n.splice(t, 1);
            }
        };
    }
    var Te = F2(function(e, n) {
        return function(t) {
            return e(n(t));
        };
    });
    function Le(e, n) {
        for(var t in n)t in e ? "init" == t ? a(6) : Le(e[t], n[t]) : e[t] = n[t];
    }
    var Ne = "undefined" != typeof document ? document : {};
    function Ce(e, n) {
        e.appendChild(n);
    }
    function Ee(e) {
        return {
            $: 0,
            a: e
        };
    }
    var qe = F2(function(e, n) {
        return F2(function(t, r) {
            for(var a = [], i = 0; r.b; r = r.b){
                var u = r.a;
                i += u.b || 0, a.push(u);
            }
            return i += a.length, {
                $: 1,
                c: n,
                d: De(t),
                e: a,
                f: e,
                b: i
            };
        });
    })(void 0);
    F2(function(e, n) {
        return F2(function(t, r) {
            for(var a = [], i = 0; r.b; r = r.b){
                var u = r.a;
                i += u.b.b || 0, a.push(u);
            }
            return i += a.length, {
                $: 2,
                c: n,
                d: De(t),
                e: a,
                f: e,
                b: i
            };
        });
    })(void 0);
    var Oe, Ie = F2(function(e, n) {
        return {
            $: "a0",
            n: e,
            o: n
        };
    }), Pe = F2(function(e, n) {
        return {
            $: "a2",
            n: e,
            o: n
        };
    }), Re = F2(function(e, n) {
        return {
            $: "a3",
            n: e,
            o: n
        };
    }), Xe = /^(on|formAction$)/i, Fe = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Je(e) {
        return Fe.test(e) ? "" : e;
    }
    function De(e) {
        for(var n = {}; e.b; e = e.b){
            var t = e.a, r = t.$, a = t.n, i = t.o;
            if ("a2" !== r) {
                var u = n[r] || (n[r] = {});
                "a3" === r && "class" === a ? Ue(u, a, i) : u[a] = i;
            } else "className" === a ? Ue(n, a, Q(i)) : n[a] = Q(i);
        }
        return n;
    }
    function Ue(e, n, t) {
        var r = e[n];
        e[n] = r ? r + " " + t : t;
    }
    function Ke(e, n) {
        var t = e.$;
        if (5 === t) return Ke(e.k || (e.k = e.m()), n);
        if (0 === t) return Ne.createTextNode(e.a);
        if (4 === t) {
            for(var r = e.k, a = e.j; 4 === r.$;)"object" != typeof a ? a = [
                a,
                r.j
            ] : a.push(r.j), r = r.k;
            var i = {
                j: a,
                p: n
            };
            return (u = Ke(r, i)).elm_event_node_ref = i, u;
        }
        if (3 === t) return Be(u = e.h(e.g), n, e.d), u;
        var u = e.f ? Ne.createElementNS(e.f, e.c) : Ne.createElement(e.c);
        Be(u, n, e.d);
        for(var o = e.e, c = 0; o.length > c; c++)Ce(u, Ke(1 === t ? o[c] : o[c].b, n));
        return u;
    }
    function Be(e, n, t) {
        for(var r in t){
            var a = t[r];
            "a1" === r ? Ge(e, a) : "a0" === r ? We(e, n, a) : "a3" === r ? He(e, a) : "a4" === r ? Me(e, a) : ("value" !== r && "checked" !== r || e[r] !== a) && (e[r] = a);
        }
    }
    function Ge(e, n) {
        var t = e.style;
        for(var r in n)t[r] = n[r];
    }
    function He(e, n) {
        for(var t in n){
            var r = n[t];
            void 0 !== r ? e.setAttribute(t, r) : e.removeAttribute(t);
        }
    }
    function Me(e, n) {
        for(var t in n){
            var r = n[t], a = r.f, i = r.o;
            void 0 !== i ? e.setAttributeNS(a, t, i) : e.removeAttributeNS(a, t);
        }
    }
    function We(e, n, t) {
        var r = e.elmFs || (e.elmFs = {});
        for(var a in t){
            var i = t[a], u = r[a];
            if (i) {
                if (u) {
                    if (u.q.$ === i.$) {
                        u.q = i;
                        continue;
                    }
                    e.removeEventListener(a, u);
                }
                u = Ye(n, i), e.addEventListener(a, u, Oe && {
                    passive: 2 > Ct(i)
                }), r[a] = u;
            } else e.removeEventListener(a, u), r[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Oe = !0;
            }
        }));
    } catch (e) {}
    function Ye(e, n) {
        function t(n) {
            var r = t.q, a = D(r.a, n);
            if (At(a)) {
                for(var i, u = Ct(r), o = a.a, c = u ? 3 > u ? o.a : o.aa : o, s = 1 == u ? o.b : 3 == u && o.aB, f = (s && n.stopPropagation(), (2 == u ? o.b : 3 == u && o.ay) && n.preventDefault(), e); i = f.j;){
                    if ("function" == typeof i) c = i(c);
                    else for(var l = i.length; l--;)c = i[l](c);
                    f = f.p;
                }
                f(c, s);
            }
        }
        return t.q = n, t;
    }
    function Qe(e, n) {
        return e.$ == n.$ && H(e.a, n.a);
    }
    function Ve(e, n, t, r) {
        var a = {
            $: n,
            r: t,
            s: r,
            t: void 0,
            u: void 0
        };
        return e.push(a), a;
    }
    function Ze(e, n, t, r) {
        if (e !== n) {
            var a = e.$, i = n.$;
            if (a !== i) {
                if (1 !== a || 2 !== i) return void Ve(t, 0, r, n);
                n = function(e) {
                    for(var n = e.e, t = n.length, r = Array(t), a = 0; t > a; a++)r[a] = n[a].b;
                    return {
                        $: 1,
                        c: e.c,
                        d: e.d,
                        e: r,
                        f: e.f,
                        b: e.b
                    };
                }(n), i = 1;
            }
            switch(i){
                case 5:
                    for(var u = e.l, o = n.l, c = u.length, s = c === o.length; s && c--;)s = u[c] === o[c];
                    if (s) return void (n.k = e.k);
                    n.k = n.m();
                    var f = [];
                    return Ze(e.k, n.k, f, 0), void (f.length > 0 && Ve(t, 1, r, f));
                case 4:
                    for(var l = e.j, h = n.j, b = !1, p = e.k; 4 === p.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        p.j
                    ] : l.push(p.j), p = p.k;
                    for(var d = n.k; 4 === d.$;)b = !0, "object" != typeof h ? h = [
                        h,
                        d.j
                    ] : h.push(d.j), d = d.k;
                    return b && l.length !== h.length ? void Ve(t, 0, r, n) : ((b ? function(e, n) {
                        for(var t = 0; e.length > t; t++)if (e[t] !== n[t]) return !1;
                        return !0;
                    }(l, h) : l === h) || Ve(t, 2, r, h), void Ze(p, d, t, r + 1));
                case 0:
                    return void (e.a !== n.a && Ve(t, 3, r, n.a));
                case 1:
                    return void en(e, n, t, r, tn);
                case 2:
                    return void en(e, n, t, r, rn);
                case 3:
                    if (e.h !== n.h) return void Ve(t, 0, r, n);
                    var g = nn(e.d, n.d);
                    g && Ve(t, 4, r, g);
                    var v = n.i(e.g, n.g);
                    return void (v && Ve(t, 5, r, v));
            }
        }
    }
    function en(e, n, t, r, a) {
        if (e.c === n.c && e.f === n.f) {
            var i = nn(e.d, n.d);
            i && Ve(t, 4, r, i), a(e, n, t, r);
        } else Ve(t, 0, r, n);
    }
    function nn(e, n, t) {
        var r;
        for(var a in e)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in n) {
                var i = e[a], u = n[a];
                i === u && "value" !== a && "checked" !== a || "a0" === t && Qe(i, u) || ((r = r || {})[a] = u);
            } else (r = r || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: e[a].f,
                o: void 0
            } : "string" == typeof e[a] ? "" : null;
        } else {
            var o = nn(e[a], n[a] || {}, a);
            o && ((r = r || {})[a] = o);
        }
        for(var c in n)c in e || ((r = r || {})[c] = n[c]);
        return r;
    }
    function tn(e, n, t, r) {
        var a = e.e, i = n.e, u = a.length, o = i.length;
        u > o ? Ve(t, 6, r, {
            v: o,
            i: u - o
        }) : o > u && Ve(t, 7, r, {
            v: u,
            e: i
        });
        for(var c = o > u ? u : o, s = 0; c > s; s++){
            var f = a[s];
            Ze(f, i[s], t, ++r), r += f.b || 0;
        }
    }
    function rn(e, n, t, r) {
        for(var a = [], i = {}, u = [], o = e.e, c = n.e, s = o.length, f = c.length, l = 0, h = 0, b = r; s > l && f > h;){
            var p = (z = o[l]).a, d = (A = c[h]).a, g = z.b, v = A.b, m = void 0, $ = void 0;
            if (p !== d) {
                var y = o[l + 1], w = c[h + 1];
                if (y) {
                    var k = y.a, x = y.b;
                    $ = d === k;
                }
                if (w) {
                    var _ = w.a, j = w.b;
                    m = p === _;
                }
                if (m && $) Ze(g, j, a, ++b), un(i, a, p, v, h, u), b += g.b || 0, on(i, a, p, x, ++b), b += x.b || 0, l += 2, h += 2;
                else if (m) b++, un(i, a, d, v, h, u), Ze(g, j, a, b), b += g.b || 0, l += 1, h += 2;
                else if ($) on(i, a, p, g, ++b), b += g.b || 0, Ze(x, v, a, ++b), b += x.b || 0, l += 2, h += 1;
                else {
                    if (!y || k !== _) break;
                    on(i, a, p, g, ++b), un(i, a, d, v, h, u), b += g.b || 0, Ze(x, j, a, ++b), b += x.b || 0, l += 2, h += 2;
                }
            } else Ze(g, v, a, ++b), b += g.b || 0, l++, h++;
        }
        for(; s > l;){
            var z;
            b++, on(i, a, (z = o[l]).a, g = z.b, b), b += g.b || 0, l++;
        }
        for(; f > h;){
            var A, S = S || [];
            un(i, a, (A = c[h]).a, A.b, void 0, S), h++;
        }
        (a.length > 0 || u.length > 0 || S) && Ve(t, 8, r, {
            w: a,
            x: u,
            y: S
        });
    }
    var an = "_elmW6BL";
    function un(e, n, t, r, a, i) {
        var u = e[t];
        if (!u) return i.push({
            r: a,
            A: u = {
                c: 0,
                z: r,
                r: a,
                s: void 0
            }
        }), void (e[t] = u);
        if (1 === u.c) {
            i.push({
                r: a,
                A: u
            }), u.c = 2;
            var o = [];
            return Ze(u.z, r, o, u.r), u.r = a, void (u.s.s = {
                w: o,
                A: u
            });
        }
        un(e, n, t + an, r, a, i);
    }
    function on(e, n, t, r, a) {
        var i = e[t];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var u = [];
                return Ze(r, i.z, u, a), void Ve(n, 9, a, {
                    w: u,
                    A: i
                });
            }
            on(e, n, t + an, r, a);
        } else {
            var o = Ve(n, 9, a, void 0);
            e[t] = {
                c: 1,
                z: r,
                r: a,
                s: o
            };
        }
    }
    function cn(e, n, t, r) {
        sn(e, n, t, 0, 0, n.b, r);
    }
    function sn(e, n, t, r, a, i, u) {
        for(var o = t[r], c = o.r; c === a;){
            var s = o.$;
            if (1 === s) cn(e, n.k, o.s, u);
            else if (8 === s) o.t = e, o.u = u, (f = o.s.w).length > 0 && sn(e, n, f, 0, a, i, u);
            else if (9 === s) {
                o.t = e, o.u = u;
                var f, l = o.s;
                l && (l.A.s = e, (f = l.w).length > 0 && sn(e, n, f, 0, a, i, u));
            } else o.t = e, o.u = u;
            if (!(o = t[++r]) || (c = o.r) > i) return r;
        }
        var h = n.$;
        if (4 === h) {
            for(var b = n.k; 4 === b.$;)b = b.k;
            return sn(e, b, t, r, a + 1, i, e.elm_event_node_ref);
        }
        for(var p = n.e, d = e.childNodes, g = 0; p.length > g; g++){
            a++;
            var v = 1 === h ? p[g] : p[g].b, m = a + (v.b || 0);
            if (!(a > c || c > m || (o = t[r = sn(d[g], v, t, r, a, m, u)]) && (c = o.r) <= i)) return r;
            a = m;
        }
        return r;
    }
    function fn(e, n) {
        for(var t = 0; n.length > t; t++){
            var r = n[t], a = r.t, i = ln(a, r);
            a === e && (e = i);
        }
        return e;
    }
    function ln(e, n) {
        switch(n.$){
            case 0:
                return function(e, n, t) {
                    var r = e.parentNode, a = Ke(n, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = e.elm_event_node_ref), r && a !== e && r.replaceChild(a, e), a;
                }(e, n.s, n.u);
            case 4:
                return Be(e, n.u, n.s), e;
            case 3:
                return e.replaceData(0, e.length, n.s), e;
            case 1:
                return fn(e, n.s);
            case 2:
                return e.elm_event_node_ref ? e.elm_event_node_ref.j = n.s : e.elm_event_node_ref = {
                    j: n.s,
                    p: n.u
                }, e;
            case 6:
                for(var t = n.s, r = 0; t.i > r; r++)e.removeChild(e.childNodes[t.v]);
                return e;
            case 7:
                for(var i = (t = n.s).e, u = e.childNodes[r = t.v]; i.length > r; r++)e.insertBefore(Ke(i[r], n.u), u);
                return e;
            case 9:
                if (!(t = n.s)) return e.parentNode.removeChild(e), e;
                var o = t.A;
                return void 0 !== o.r && e.parentNode.removeChild(e), o.s = fn(e, t.w), e;
            case 8:
                return function(e, n) {
                    var t = n.s, r = function(e, n) {
                        if (e) {
                            for(var t = Ne.createDocumentFragment(), r = 0; e.length > r; r++){
                                var a = e[r].A;
                                Ce(t, 2 === a.c ? a.s : Ke(a.z, n.u));
                            }
                            return t;
                        }
                    }(t.y, n);
                    e = fn(e, t.w);
                    for(var a = t.x, i = 0; a.length > i; i++){
                        var u = a[i], o = u.A, c = 2 === o.c ? o.s : Ke(o.z, n.u);
                        e.insertBefore(c, e.childNodes[u.r]);
                    }
                    return r && Ce(e, r), e;
                }(e, n);
            case 5:
                return n.s(e);
            default:
                a(10);
        }
    }
    function hn(e) {
        if (3 === e.nodeType) return Ee(e.textContent);
        if (1 !== e.nodeType) return Ee("");
        for(var n = g, t = e.attributes, r = t.length; r--;){
            var a = t[r];
            n = v(A2(Re, a.name, a.value), n);
        }
        var i = e.tagName.toLowerCase(), u = g, o = e.childNodes;
        for(r = o.length; r--;)u = v(hn(o[r]), u);
        return A3(qe, i, n, u);
    }
    var bn = F4(function(e, n, t, r) {
        return function(e, n, t, r, i, u) {
            var o = A2(J, e, n ? n.flags : void 0);
            At(o) || a(2);
            var c = {}, s = t(o.a), f = s.a, l = u(b, f), h = function(e, n) {
                var t;
                for(var r in be){
                    var a = be[r];
                    a.a && ((t = t || {})[r] = a.a(r, n)), e[r] = de(a, n);
                }
                return t;
            }(c, b);
            function b(e, n) {
                var t = A2(r, e, f);
                l(f = t.a, n), ke(c, t.b, i(f));
            }
            return ke(c, s.b, i(f)), h ? {
                ports: h
            } : {};
        }(n, r, e.b$, e.cH, e.cB, function(n, t) {
            var a = e.cI, i = r.node, u = hn(i);
            return function(e, n) {
                n(e);
                var t = 0;
                function r() {
                    t = 1 === t ? 0 : (pn(r), n(e), 1);
                }
                return function(a, i) {
                    e = a, i ? (n(e), 2 === t && (t = 1)) : (0 === t && pn(r), t = 2);
                };
            }(t, function(e) {
                var t = a(e), r = function(e, n) {
                    var t = [];
                    return Ze(e, n, t, 0), t;
                }(u, t);
                i = function(e, n, t, r) {
                    return 0 === t.length ? e : (cn(e, n, t, r), fn(e, t));
                }(i, u, r, n), u = t;
            });
        });
    }), pn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(e) {
        return setTimeout(e, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var dn = F2(function(e, n) {
        return ne(function() {
            var t = setInterval(function() {
                ie(n);
            }, e);
            return function() {
                clearInterval(t);
            };
        });
    }), gn = F2(function(e, n) {
        return ne(function(t) {
            var r = new XMLHttpRequest;
            !function(e, n) {
                Cr(n) && e.addEventListener("progress", function(e) {
                    e.lengthComputable && ie(n.a({
                        bH: e.loaded,
                        bI: e.total
                    }));
                });
            }(r, n), r.addEventListener("error", function() {
                t(ee(Sr));
            }), r.addEventListener("timeout", function() {
                t(ee(Tr));
            }), r.addEventListener("load", function() {
                t(function(e, n) {
                    var t = function(e) {
                        return {
                            aE: e.responseURL,
                            cA: {
                                bL: e.status,
                                aa: e.statusText
                            },
                            aX: vn(e.getAllResponseHeaders()),
                            bD: e.response
                        };
                    }(e);
                    if (200 > e.status || e.status >= 300) return t.body = e.responseText, ee(zr(t));
                    var r = n(t);
                    return At(r) ? Z(r.a) : (t.body = e.responseText, ee(A2(jr, r.a, t)));
                }(r, e.aR.a));
            });
            try {
                r.open(e.b5, e.aE, !0);
            } catch (n) {
                return t(ee(Ar(e.aE)));
            }
            !function(e, n) {
                for(var t = n.aX; t.b; t = t.b)e.setRequestHeader(t.a.a, t.a.b);
                e.responseType = n.aR.b, e.withCredentials = n.cJ, Cr(n.bq) && (e.timeout = n.bq.a);
            }(r, e);
            var a = e.bD;
            return r.send(Er(a) ? (r.setRequestHeader("Content-Type", a.a), a.b) : a.a), function() {
                r.abort();
            };
        });
    });
    function vn(e) {
        var n = Nr;
        if (!e) return n;
        for(var t = e.split("\r\n"), r = t.length; r--;){
            var a = t[r], i = a.indexOf(": ");
            if (i > 0) {
                var u = a.substring(0, i), o = a.substring(i + 2);
                n = A3(Hr, u, function(e) {
                    return Pn(Cr(e) ? o + ", " + e.a : o);
                }, n);
            }
        }
        return n;
    }
    var mn = F3(function(e, n, t) {
        return function(e, n, t, r) {
            return {
                $: 3,
                d: De(e),
                g: n,
                h: t,
                i: r
            };
        }(n, {
            a: e,
            b: t
        }, $n, yn);
    });
    function $n(e) {
        return A2(xn, e, Ne.createElement("div"));
    }
    function yn(e, n) {
        return (e.b !== n.b || e.a !== n.a) && xn(n);
    }
    var wn, kn, xn = F2(function(e, n) {
        var t, r;
        return n.innerHTML = _n(e.b, {
            highlight: function(e, n) {
                return !n && Cr(t.aM) && (n = t.aM.a), "undefined" != typeof hljs && n && hljs.listLanguages().indexOf(n) >= 0 ? hljs.highlight(n, e, !0).value : e;
            },
            gfm: r = (t = e.a).bW.a,
            tables: r && r.cC,
            breaks: r && r.bE,
            sanitize: t.cu,
            smartypants: t.cw
        }), n;
    }), _n = (kn = (wn = {}).exports = {}, (function() {
        var e = {
            newline: /^\n+/,
            code: /^( {4}[^\n]+\n*)+/,
            fences: c,
            hr: /^( *[-*_]){3,} *(?:\n+|$)/,
            heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
            nptable: c,
            lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
            blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
            list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
            html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
            def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
            table: c,
            paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
            text: /^[^\n]+/
        };
        function n(n) {
            this.tokens = [], this.tokens.links = {}, this.options = n || f.defaults, this.rules = e.normal, this.options.gfm && (this.rules = this.options.tables ? e.tables : e.gfm);
        }
        e.bullet = /(?:[*+-]|\d+\.)/, e.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/, e.item = o(e.item, "gm")(/bull/g, e.bullet)(), e.list = o(e.list)(/bull/g, e.bullet)("hr", "\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def", "\\n+(?=" + e.def.source + ")")(), e.blockquote = o(e.blockquote)("def", e.def)(), e._tag = "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b", e.html = o(e.html)("comment", /<!--[\s\S]*?-->/)("closed", /<(tag)[\s\S]+?<\/\1>/)("closing", /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g, e._tag)(), e.paragraph = o(e.paragraph)("hr", e.hr)("heading", e.heading)("lheading", e.lheading)("blockquote", e.blockquote)("tag", "<" + e._tag)("def", e.def)(), e.normal = s({}, e), e.gfm = s({}, e.normal, {
            fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
            paragraph: /^/,
            heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
        }), e.gfm.paragraph = o(e.paragraph)("(?!", "(?!" + e.gfm.fences.source.replace("\\1", "\\2") + "|" + e.list.source.replace("\\1", "\\3") + "|")(), e.tables = s({}, e.gfm, {
            nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
            table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
        }), n.rules = e, n.lex = function(e, t) {
            return new n(t).lex(e);
        }, n.prototype.lex = function(e) {
            return e = e.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ").replace(/\u00a0/g, " ").replace(/\u2424/g, "\n"), this.token(e, !0);
        }, n.prototype.token = function(n, t, r) {
            var a, i, u, o, c, s, f, l, h;
            for(n = n.replace(/^ +$/gm, ""); n;)if ((u = this.rules.newline.exec(n)) && (n = n.substring(u[0].length), u[0].length > 1 && this.tokens.push({
                type: "space"
            })), u = this.rules.code.exec(n)) n = n.substring(u[0].length), u = u[0].replace(/^ {4}/gm, ""), this.tokens.push({
                type: "code",
                text: this.options.pedantic ? u : u.replace(/\n+$/, "")
            });
            else if (u = this.rules.fences.exec(n)) n = n.substring(u[0].length), this.tokens.push({
                type: "code",
                lang: u[2],
                text: u[3] || ""
            });
            else if (u = this.rules.heading.exec(n)) n = n.substring(u[0].length), this.tokens.push({
                type: "heading",
                depth: u[1].length,
                text: u[2]
            });
            else if (t && (u = this.rules.nptable.exec(n))) {
                for(n = n.substring(u[0].length), s = {
                    type: "table",
                    header: u[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                    align: u[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: u[3].replace(/\n$/, "").split("\n")
                }, l = 0; s.align.length > l; l++)s.align[l] = /^ *-+: *$/.test(s.align[l]) ? "right" : /^ *:-+: *$/.test(s.align[l]) ? "center" : /^ *:-+ *$/.test(s.align[l]) ? "left" : null;
                for(l = 0; s.cells.length > l; l++)s.cells[l] = s.cells[l].split(/ *\| */);
                this.tokens.push(s);
            } else if (u = this.rules.lheading.exec(n)) n = n.substring(u[0].length), this.tokens.push({
                type: "heading",
                depth: "=" === u[2] ? 1 : 2,
                text: u[1]
            });
            else if (u = this.rules.hr.exec(n)) n = n.substring(u[0].length), this.tokens.push({
                type: "hr"
            });
            else if (u = this.rules.blockquote.exec(n)) n = n.substring(u[0].length), this.tokens.push({
                type: "blockquote_start"
            }), u = u[0].replace(/^ *> ?/gm, ""), this.token(u, t, !0), this.tokens.push({
                type: "blockquote_end"
            });
            else if (u = this.rules.list.exec(n)) {
                for(n = n.substring(u[0].length), this.tokens.push({
                    type: "list_start",
                    ordered: (o = u[2]).length > 1
                }), a = !1, h = (u = u[0].match(this.rules.item)).length, l = 0; h > l; l++)f = (s = u[l]).length, ~(s = s.replace(/^ *([*+-]|\d+\.) +/, "")).indexOf("\n ") && (f -= s.length, s = s.replace(this.options.pedantic ? /^ {1,4}/gm : RegExp("^ {1," + f + "}", "gm"), "")), this.options.smartLists && l !== h - 1 && (o === (c = e.bullet.exec(u[l + 1])[0]) || o.length > 1 && c.length > 1 || (n = u.slice(l + 1).join("\n") + n, l = h - 1)), i = a || /\n\n(?!\s*$)/.test(s), l !== h - 1 && (a = "\n" === s.charAt(s.length - 1), i || (i = a)), this.tokens.push({
                    type: i ? "loose_item_start" : "list_item_start"
                }), this.token(s, !1, r), this.tokens.push({
                    type: "list_item_end"
                });
                this.tokens.push({
                    type: "list_end"
                });
            } else if (u = this.rules.html.exec(n)) n = n.substring(u[0].length), this.tokens.push({
                type: this.options.sanitize ? "paragraph" : "html",
                pre: !this.options.sanitizer && ("pre" === u[1] || "script" === u[1] || "style" === u[1]),
                text: u[0]
            });
            else if (!r && t && (u = this.rules.def.exec(n))) n = n.substring(u[0].length), this.tokens.links[u[1].toLowerCase()] = {
                href: u[2],
                title: u[3]
            };
            else if (t && (u = this.rules.table.exec(n))) {
                for(n = n.substring(u[0].length), s = {
                    type: "table",
                    header: u[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                    align: u[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: u[3].replace(/(?: *\| *)?\n$/, "").split("\n")
                }, l = 0; s.align.length > l; l++)s.align[l] = /^ *-+: *$/.test(s.align[l]) ? "right" : /^ *:-+: *$/.test(s.align[l]) ? "center" : /^ *:-+ *$/.test(s.align[l]) ? "left" : null;
                for(l = 0; s.cells.length > l; l++)s.cells[l] = s.cells[l].replace(/^ *\| *| *\| *$/g, "").split(/ *\| */);
                this.tokens.push(s);
            } else if (t && (u = this.rules.paragraph.exec(n))) n = n.substring(u[0].length), this.tokens.push({
                type: "paragraph",
                text: "\n" === u[1].charAt(u[1].length - 1) ? u[1].slice(0, -1) : u[1]
            });
            else if (u = this.rules.text.exec(n)) n = n.substring(u[0].length), this.tokens.push({
                type: "text",
                text: u[0]
            });
            else if (n) throw Error("Infinite loop on byte: " + n.charCodeAt(0));
            return this.tokens;
        };
        var t = {
            escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
            autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
            url: c,
            tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
            link: /^!?\[(inside)\]\(href\)/,
            reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
            nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
            strong: /^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
            em: /^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
            code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
            br: /^ {2,}\n(?!\s*$)/,
            del: c,
            text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
        };
        function r(e, n) {
            if (this.options = n || f.defaults, this.links = e, this.rules = t.normal, this.renderer = this.options.renderer || new a, this.renderer.options = this.options, !this.links) throw Error("Tokens array requires a `links` property.");
            this.options.gfm ? this.rules = this.options.breaks ? t.breaks : t.gfm : this.options.pedantic && (this.rules = t.pedantic);
        }
        function a(e) {
            this.options = e || {};
        }
        function i(e) {
            this.tokens = [], this.token = null, this.options = e || f.defaults, this.options.renderer = this.options.renderer || new a, this.renderer = this.options.renderer, this.renderer.options = this.options;
        }
        function u(e, n) {
            return e.replace(n ? /&/g : /&(?!#?\w+;)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        }
        function o(e, n) {
            return e = e.source, n = n || "", function t(r, a) {
                return r ? (a = (a = a.source || a).replace(/(^|[^\[])\^/g, "$1"), e = e.replace(r, a), t) : RegExp(e, n);
            };
        }
        function c() {}
        function s(e) {
            for(var n, t, r = 1; arguments.length > r; r++)for(t in n = arguments[r])Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
            return e;
        }
        function f(e, t, r) {
            if (r || "function" == typeof t) {
                r || (r = t, t = null);
                var a, o, c = (t = s({}, f.defaults, t || {})).highlight, l = 0;
                try {
                    a = n.lex(e, t);
                } catch (e) {
                    return r(e);
                }
                o = a.length;
                var h = function(e) {
                    if (e) return t.highlight = c, r(e);
                    var n;
                    try {
                        n = i.parse(a, t);
                    } catch (n) {
                        e = n;
                    }
                    return t.highlight = c, e ? r(e) : r(null, n);
                };
                if (!c || 3 > c.length) return h();
                if (delete t.highlight, !o) return h();
                for(; a.length > l; l++)(function(e) {
                    "code" !== e.type ? --o || h() : c(e.text, e.lang, function(n, t) {
                        return n ? h(n) : null == t || t === e.text ? --o || h() : (e.text = t, e.escaped = !0, void (--o || h()));
                    });
                })(a[l]);
            } else try {
                return t && (t = s({}, f.defaults, t)), i.parse(n.lex(e, t), t);
            } catch (e) {
                if (e.message += "\nPlease report this to https://github.com/chjj/marked.", (t || f.defaults).silent) return "<p>An error occured:</p><pre>" + u(e.message + "", !0) + "</pre>";
                throw e;
            }
        }
        t._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/, t._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/, t.link = o(t.link)("inside", t._inside)("href", t._href)(), t.reflink = o(t.reflink)("inside", t._inside)(), t.normal = s({}, t), t.pedantic = s({}, t.normal, {
            strong: /^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
        }), t.gfm = s({}, t.normal, {
            escape: o(t.escape)("])", "~|])")(),
            url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
            del: /^~~(?=\S)([\s\S]*?\S)~~/,
            text: o(t.text)("]|", "~]|")("|", "|https?://|")()
        }), t.breaks = s({}, t.gfm, {
            br: o(t.br)("{2,}", "*")(),
            text: o(t.gfm.text)("{2,}", "*")()
        }), r.rules = t, r.output = function(e, n, t) {
            return new r(n, t).output(e);
        }, r.prototype.output = function(e) {
            for(var n, t, r, a, i = ""; e;)if (a = this.rules.escape.exec(e)) e = e.substring(a[0].length), i += a[1];
            else if (a = this.rules.autolink.exec(e)) e = e.substring(a[0].length), "@" === a[2] ? (t = ":" === a[1].charAt(6) ? this.mangle(a[1].substring(7)) : this.mangle(a[1]), r = this.mangle("mailto:") + t) : r = t = u(a[1]), i += this.renderer.link(r, null, t);
            else if (this.inLink || !(a = this.rules.url.exec(e))) {
                if (a = this.rules.tag.exec(e)) !this.inLink && /^<a /i.test(a[0]) ? this.inLink = !0 : this.inLink && /^<\/a>/i.test(a[0]) && (this.inLink = !1), e = e.substring(a[0].length), i += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(a[0]) : u(a[0]) : a[0];
                else if (a = this.rules.link.exec(e)) e = e.substring(a[0].length), this.inLink = !0, i += this.outputLink(a, {
                    href: a[2],
                    title: a[3]
                }), this.inLink = !1;
                else if ((a = this.rules.reflink.exec(e)) || (a = this.rules.nolink.exec(e))) {
                    if (e = e.substring(a[0].length), n = (a[2] || a[1]).replace(/\s+/g, " "), !(n = this.links[n.toLowerCase()]) || !n.href) {
                        i += a[0].charAt(0), e = a[0].substring(1) + e;
                        continue;
                    }
                    this.inLink = !0, i += this.outputLink(a, n), this.inLink = !1;
                } else if (a = this.rules.strong.exec(e)) e = e.substring(a[0].length), i += this.renderer.strong(this.output(a[2] || a[1]));
                else if (a = this.rules.em.exec(e)) e = e.substring(a[0].length), i += this.renderer.em(this.output(a[2] || a[1]));
                else if (a = this.rules.code.exec(e)) e = e.substring(a[0].length), i += this.renderer.codespan(u(a[2], !0));
                else if (a = this.rules.br.exec(e)) e = e.substring(a[0].length), i += this.renderer.br();
                else if (a = this.rules.del.exec(e)) e = e.substring(a[0].length), i += this.renderer.del(this.output(a[1]));
                else if (a = this.rules.text.exec(e)) e = e.substring(a[0].length), i += this.renderer.text(u(this.smartypants(a[0])));
                else if (e) throw Error("Infinite loop on byte: " + e.charCodeAt(0));
            } else e = e.substring(a[0].length), t = u(a[1]), i += this.renderer.link(r = t, null, t);
            return i;
        }, r.prototype.outputLink = function(e, n) {
            var t = u(n.href), r = n.title ? u(n.title) : null;
            return "!" !== e[0].charAt(0) ? this.renderer.link(t, r, this.output(e[1])) : this.renderer.image(t, r, u(e[1]));
        }, r.prototype.smartypants = function(e) {
            return this.options.smartypants ? e.replace(/---/g, "\u2014").replace(/--/g, "\u2013").replace(/(^|[-\u2014\/(\[{"\s])'/g, "$1\u2018").replace(/'/g, "\u2019").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g, "$1\u201C").replace(/"/g, "\u201D").replace(/\.{3}/g, "\u2026") : e;
        }, r.prototype.mangle = function(e) {
            if (!this.options.mangle) return e;
            for(var n, t = "", r = e.length, a = 0; r > a; a++)n = e.charCodeAt(a), Math.random() > .5 && (n = "x" + n.toString(16)), t += "&#" + n + ";";
            return t;
        }, a.prototype.code = function(e, n, t) {
            if (this.options.highlight) {
                var r = this.options.highlight(e, n);
                null != r && r !== e && (t = !0, e = r);
            }
            return n ? '<pre><code class="' + this.options.langPrefix + u(n, !0) + '">' + (t ? e : u(e, !0)) + "\n</code></pre>\n" : "<pre><code>" + (t ? e : u(e, !0)) + "\n</code></pre>";
        }, a.prototype.blockquote = function(e) {
            return "<blockquote>\n" + e + "</blockquote>\n";
        }, a.prototype.html = function(e) {
            return e;
        }, a.prototype.heading = function(e, n, t) {
            return "<h" + n + ' id="' + this.options.headerPrefix + t.toLowerCase().replace(/[^\w]+/g, "-") + '">' + e + "</h" + n + ">\n";
        }, a.prototype.hr = function() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        }, a.prototype.list = function(e, n) {
            var t = n ? "ol" : "ul";
            return "<" + t + ">\n" + e + "</" + t + ">\n";
        }, a.prototype.listitem = function(e) {
            return "<li>" + e + "</li>\n";
        }, a.prototype.paragraph = function(e) {
            return "<p>" + e + "</p>\n";
        }, a.prototype.table = function(e, n) {
            return "<table>\n<thead>\n" + e + "</thead>\n<tbody>\n" + n + "</tbody>\n</table>\n";
        }, a.prototype.tablerow = function(e) {
            return "<tr>\n" + e + "</tr>\n";
        }, a.prototype.tablecell = function(e, n) {
            var t = n.header ? "th" : "td";
            return (n.align ? "<" + t + ' style="text-align:' + n.align + '">' : "<" + t + ">") + e + "</" + t + ">\n";
        }, a.prototype.strong = function(e) {
            return "<strong>" + e + "</strong>";
        }, a.prototype.em = function(e) {
            return "<em>" + e + "</em>";
        }, a.prototype.codespan = function(e) {
            return "<code>" + e + "</code>";
        }, a.prototype.br = function() {
            return this.options.xhtml ? "<br/>" : "<br>";
        }, a.prototype.del = function(e) {
            return "<del>" + e + "</del>";
        }, a.prototype.link = function(e, n, t) {
            if (this.options.sanitize) {
                try {
                    var r = decodeURIComponent((a = e, a.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(e, n) {
                        return "colon" === (n = n.toLowerCase()) ? ":" : "#" === n.charAt(0) ? "x" === n.charAt(1) ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1)) : "";
                    }))).replace(/[^\w:]/g, "").toLowerCase();
                } catch (e) {
                    return "";
                }
                if (0 === r.indexOf("javascript:") || 0 === r.indexOf("vbscript:") || 0 === r.indexOf("data:")) return "";
            }
            var a, i = '<a href="' + e + '"';
            return n && (i += ' title="' + n + '"'), i + ">" + t + "</a>";
        }, a.prototype.image = function(e, n, t) {
            var r = '<img src="' + e + '" alt="' + t + '"';
            return n && (r += ' title="' + n + '"'), r + (this.options.xhtml ? "/>" : ">");
        }, a.prototype.text = function(e) {
            return e;
        }, i.parse = function(e, n, t) {
            return new i(n, t).parse(e);
        }, i.prototype.parse = function(e) {
            this.inline = new r(e.links, this.options, this.renderer), this.tokens = e.reverse();
            for(var n = ""; this.next();)n += this.tok();
            return n;
        }, i.prototype.next = function() {
            return this.token = this.tokens.pop();
        }, i.prototype.peek = function() {
            return this.tokens[this.tokens.length - 1] || 0;
        }, i.prototype.parseText = function() {
            for(var e = this.token.text; "text" === this.peek().type;)e += "\n" + this.next().text;
            return this.inline.output(e);
        }, i.prototype.tok = function() {
            switch(this.token.type){
                case "space":
                    return "";
                case "hr":
                    return this.renderer.hr();
                case "heading":
                    return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, this.token.text);
                case "code":
                    return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
                case "table":
                    var e, n, t, r, a = "", i = "";
                    for(t = "", e = 0; this.token.header.length > e; e++)t += this.renderer.tablecell(this.inline.output(this.token.header[e]), {
                        header: !0,
                        align: this.token.align[e]
                    });
                    for(a += this.renderer.tablerow(t), e = 0; this.token.cells.length > e; e++){
                        for(n = this.token.cells[e], t = "", r = 0; n.length > r; r++)t += this.renderer.tablecell(this.inline.output(n[r]), {
                            header: !1,
                            align: this.token.align[r]
                        });
                        i += this.renderer.tablerow(t);
                    }
                    return this.renderer.table(a, i);
                case "blockquote_start":
                    for(i = ""; "blockquote_end" !== this.next().type;)i += this.tok();
                    return this.renderer.blockquote(i);
                case "list_start":
                    i = "";
                    for(var u = this.token.ordered; "list_end" !== this.next().type;)i += this.tok();
                    return this.renderer.list(i, u);
                case "list_item_start":
                    for(i = ""; "list_item_end" !== this.next().type;)i += "text" === this.token.type ? this.parseText() : this.tok();
                    return this.renderer.listitem(i);
                case "loose_item_start":
                    for(i = ""; "list_item_end" !== this.next().type;)i += this.tok();
                    return this.renderer.listitem(i);
                case "html":
                    var o = this.token.pre || this.options.pedantic ? this.token.text : this.inline.output(this.token.text);
                    return this.renderer.html(o);
                case "paragraph":
                    return this.renderer.paragraph(this.inline.output(this.token.text));
                case "text":
                    return this.renderer.paragraph(this.parseText());
            }
        }, c.exec = c, f.options = f.setOptions = function(e) {
            return s(f.defaults, e), f;
        }, f.defaults = {
            gfm: !0,
            tables: !0,
            breaks: !1,
            pedantic: !1,
            sanitize: !1,
            sanitizer: null,
            mangle: !0,
            smartLists: !1,
            silent: !1,
            highlight: null,
            langPrefix: "lang-",
            smartypants: !1,
            headerPrefix: "",
            renderer: new a,
            xhtml: !1
        }, f.Parser = i, f.parser = i.parse, f.Renderer = a, f.Lexer = n, f.lexer = n.lex, f.InlineLexer = r, f.inlineLexer = r.output, f.parse = f, void 0 !== wn && "object" == typeof kn ? wn.exports = f : "function" == typeof define && define.amd ? define(function() {
            return f;
        }) : this.marked = f;
    }).call(function() {
        return this || ("undefined" != typeof window ? window : $parcel$global);
    }()), wn.exports), jn = m, zn = F3(function(e, n, t) {
        for(;;){
            if (-2 === t.$) return n;
            var r = t.d, a = e, i = A3(e, t.b, t.c, A3(zn, e, n, t.e));
            e = a, n = i, t = r;
        }
    }), An = function(e) {
        return A3(zn, F3(function(e, n, t) {
            return A2(jn, l(e, n), t);
        }), g, e);
    }, Sn = 1, Tn = 2, Ln = 0, Nn = function(e) {
        return {
            $: 1,
            a: e
        };
    }, Cn = F2(function(e, n) {
        return {
            $: 3,
            a: e,
            b: n
        };
    }), En = F2(function(e, n) {
        return {
            $: 0,
            a: e,
            b: n
        };
    }), qn = F2(function(e, n) {
        return {
            $: 1,
            a: e,
            b: n
        };
    }), On = function(e) {
        return {
            $: 0,
            a: e
        };
    }, In = function(e) {
        return {
            $: 2,
            a: e
        };
    }, Pn = function(e) {
        return {
            $: 0,
            a: e
        };
    }, Rn = {
        $: 1
    }, Xn = S, Fn = W, Jn = function(e) {
        return e + "";
    }, Dn = F2(function(e, n) {
        return A2(z, e, function(e) {
            for(var n = []; e.b; e = e.b)n.push(e.a);
            return n;
        }(n));
    }), Un = F2(function(e, n) {
        return $(A2(j, e, n));
    }), Kn = function(e) {
        return A2(Dn, "\n    ", A2(Un, "\n", e));
    }, Bn = F3(function(e, n, t) {
        for(;;){
            if (!t.b) return n;
            var r = t.b, a = e, i = A2(e, t.a, n);
            e = a, n = i, t = r;
        }
    }), Gn = function(e) {
        return A3(Bn, F2(function(e, n) {
            return n + 1;
        }), 0, e);
    }, Hn = y, Mn = F3(function(e, n, t) {
        for(;;){
            if (s(e, n) >= 1) return t;
            var r = e, a = n - 1, i = A2(jn, n, t);
            e = r, n = a, t = i;
        }
    }), Wn = F2(function(e, n) {
        return A3(Mn, e, n, g);
    }), Yn = F2(function(e, n) {
        return A3(Hn, e, A2(Wn, 0, Gn(n) - 1), n);
    }), Qn = function(e) {
        var n = e.charCodeAt(0);
        return 55296 > n || n > 56319 ? n : 1024 * (n - 55296) + e.charCodeAt(1) - 56320 + 65536;
    }, Vn = function(e) {
        var n = Qn(e);
        return n >= 97 && 122 >= n;
    }, Zn = function(e) {
        var n = Qn(e);
        return 90 >= n && n >= 65;
    }, et = function(e) {
        return Vn(e) || Zn(e) || function(e) {
            var n = Qn(e);
            return 57 >= n && n >= 48;
        }(e);
    }, nt = function(e) {
        return A3(Bn, jn, g, e);
    }, tt = F2(function(e, n) {
        return "\n\n(" + Jn(e + 1) + ") " + Kn(rt(n));
    }), rt = function(e) {
        return A2(at, e, g);
    }, at = F2(function(e, n) {
        e: for(;;)switch(e.$){
            case 0:
                var t = e.a, r = e.b, a = function() {
                    var e, n, r = (n = (e = t).charCodeAt(0), isNaN(n) ? Rn : Pn(55296 > n || n > 56319 ? l(e[0], e.slice(1)) : l(e[0] + e[1], e.slice(2))));
                    if (1 === r.$) return !1;
                    var a, i = r.a, u = i.b;
                    return (Vn(a = i.a) || Zn(a)) && A2(Xn, et, u);
                }();
                e = r, n = A2(jn, a ? "." + t : "['" + t + "']", n);
                continue e;
            case 1:
                r = e.b;
                var i = "[" + Jn(e.a) + "]";
                e = r, n = A2(jn, i, n);
                continue e;
            case 2:
                var u = e.a;
                if (u.b) {
                    if (u.b.b) {
                        var o = function() {
                            return n.b ? "The Json.Decode.oneOf at json" + A2(Dn, "", nt(n)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + Jn(Gn(u)) + " ways:";
                        return A2(Dn, "\n\n", A2(jn, o, A2(Yn, tt, u)));
                    }
                    e = r = u.a;
                    continue e;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return n.b ? " at json" + A2(Dn, "", nt(n)) : "!";
                }();
            default:
                var c = e.a, s = e.b;
                return (o = function() {
                    return n.b ? "Problem with the value at json" + A2(Dn, "", nt(n)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (Kn(A2(Fn, 4, s)) + "\n\n") + c;
        }
    }), it = 32, ut = F4(function(e, n, t, r) {
        return {
            $: 0,
            a: e,
            b: n,
            c: t,
            d: r
        };
    }), ot = [], ct = k, st = F2(function(e, n) {
        return _(n) / _(e);
    }), ft = ct(A2(st, 2, it)), lt = A4(ut, 0, ft, ot, ot), ht = t, bt = function(e) {
        return {
            $: 1,
            a: e
        };
    }, pt = F2(function(e, n) {
        return n(e);
    }), dt = o, gt = x, vt = function(e) {
        return e.length;
    }, mt = F2(function(e, n) {
        return s(e, n) > 0 ? e : n;
    }), $t = function(e) {
        return {
            $: 0,
            a: e
        };
    }, yt = r, wt = F2(function(e, n) {
        for(;;){
            var t = A2(yt, it, e), r = t.b, a = A2(jn, $t(t.a), n);
            if (!r.b) return nt(a);
            e = r, n = a;
        }
    }), kt = function(e) {
        return e.a;
    }, xt = F2(function(e, n) {
        for(;;){
            var t = ct(n / it);
            if (1 === t) return A2(yt, it, e).a;
            e = A2(wt, e, g), n = t;
        }
    }), _t = F2(function(e, n) {
        if (n.f) {
            var t = n.f * it, r = gt(A2(st, it, t - 1)), a = e ? nt(n.i) : n.i, i = A2(xt, a, n.f);
            return A4(ut, vt(n.h) + t, A2(mt, 5, r * ft), i, n.h);
        }
        return A4(ut, vt(n.h), ft, ot, n.h);
    }), jt = F5(function(e, n, t, r, a) {
        for(;;){
            if (0 > n) return A2(_t, !1, {
                i: r,
                f: t / it | 0,
                h: a
            });
            var i = bt(A3(ht, it, n, e));
            n -= it, r = A2(jn, i, r);
        }
    }), zt = F2(function(e, n) {
        if (e > 0) {
            var t = e % it;
            return A5(jt, n, e - t - it, e, g, A3(ht, t, e - t, n));
        }
        return lt;
    }), At = function(e) {
        return !e.$;
    }, St = P, Tt = R, Lt = X, Nt = function(e) {
        return {
            $: 0,
            a: e
        };
    }, Ct = function(e) {
        switch(e.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Et = function(e) {
        return e;
    }, qt = A, Ot = F2(function(e, n) {
        return 1 > e ? n : A3(qt, e, n.length, n);
    }), It = T, Pt = Z, Rt = Pt(0), Xt = F4(function(e, n, t, r) {
        if (r.b) {
            var a = r.a, i = r.b;
            if (i.b) {
                var u = i.a, o = i.b;
                if (o.b) {
                    var c = o.a, s = o.b;
                    if (s.b) {
                        var f = s.b;
                        return A2(e, a, A2(e, u, A2(e, c, A2(e, s.a, t > 500 ? A3(Bn, e, n, nt(f)) : A4(Xt, e, n, t + 1, f)))));
                    }
                    return A2(e, a, A2(e, u, A2(e, c, n)));
                }
                return A2(e, a, A2(e, u, n));
            }
            return A2(e, a, n);
        }
        return n;
    }), Ft = F3(function(e, n, t) {
        return A4(Xt, e, n, 0, t);
    }), Jt = F2(function(e, n) {
        return A3(Ft, F2(function(n, t) {
            return A2(jn, e(n), t);
        }), g, n);
    }), Dt = te, Ut = F2(function(e, n) {
        return A2(Dt, function(n) {
            return Pt(e(n));
        }, n);
    }), Kt = F3(function(e, n, t) {
        return A2(Dt, function(n) {
            return A2(Dt, function(t) {
                return Pt(A2(e, n, t));
            }, t);
        }, n);
    }), Bt = function(e) {
        return A3(Ft, Kt(jn), Pt(g), e);
    }, Gt = ge, Ht = F2(function(e, n) {
        var t = n;
        return ue(A2(Dt, Gt(e), t));
    });
    be.Task = pe(Rt, F3(function(e, n) {
        return A2(Ut, function() {
            return 0;
        }, Bt(A2(Jt, Ht(e), n)));
    }), F3(function() {
        return Pt(0);
    }), F2(function(e, n) {
        return A2(Ut, e, n);
    }));
    var Mt, Wt = me("Task"), Yt = F2(function(e, n) {
        return Wt(A2(Ut, e, n));
    }), Qt = bn, Vt = O, Zt = {
        $: 0
    }, er = function(e) {
        return {
            $: 1,
            a: e
        };
    }, nr = $e, tr = ze("fetchSavedGames", function() {
        return null;
    }), rr = (Mt = Et, ne(function(e) {
        e(Z(Mt(Date.now())));
    })), ar = function(e) {
        return {
            $: 0,
            a: e
        };
    }, ir = F3(function(e, n, t) {
        return e(n(t));
    }), ur = function(e) {
        return {
            $: 1,
            a: e
        };
    }, or = F2(function(e, n) {
        return {
            X: n,
            aa: e
        };
    }), cr = Lt(pt), sr = F2(function(e, n) {
        return A3(Ft, Vt, n, e);
    }), fr = J, lr = function(e) {
        return {
            $: 5,
            c: e
        };
    }, hr = function(e) {
        return {
            $: 11,
            g: e
        };
    }, br = E, pr = F3(function(e, n, t) {
        var r = function(e) {
            return hr($([
                e,
                lr(t)
            ]));
        };
        return A2(St, function(a) {
            var i = A2(fr, A2(sr, e, br), a);
            if (i.$) return Nt(t);
            var u = i.a, o = A2(fr, r(n), u);
            return o.$ ? A2(sr, e, r(n)) : Nt(o.a);
        }, br);
    }), dr = F4(function(e, n, t, r) {
        return A2(cr, A3(pr, $([
            e
        ]), n, t), r);
    }), gr = F3(function(e, n, t) {
        return A2(cr, A2(Vt, e, n), t);
    }), vr = q, mr = A4(dr, "context", A2(Tt, Pn, vr), Rn, A3(gr, "message", vr, Nt(or))), $r = function(e) {
        return {
            $: 3,
            b: e
        };
    }, yr = A2(Vt, "errors", $r(mr)), wr = F, kr = function(e) {
        if (!e.$) return {
            $: 0,
            a: e.a
        };
        switch(e.a.$){
            case 3:
                var n = A2(wr, yr, e.a.a.bD);
                return ur(n.$ ? $([
                    {
                        X: Rn,
                        aa: "Invalid response from server"
                    }
                ]) : n.a);
            case 0:
                return ur($([
                    {
                        X: Rn,
                        aa: e.a.a
                    }
                ]));
            case 1:
                return ur($([
                    {
                        X: Rn,
                        aa: "Request to server timed out, please check your internet connection."
                    }
                ]));
            case 2:
                return ur($([
                    {
                        X: Rn,
                        aa: "Unable to connect to server, please check your internet connection."
                    }
                ]));
            default:
                return ur($([
                    {
                        X: Rn,
                        aa: e.a.a
                    }
                ]));
        }
    }, xr = re, _r = F2(function(e, n) {
        return Wt(A2(xr, A2(ir, A2(ir, Pt, e), Nn), A2(Dt, A2(ir, A2(ir, Pt, e), On), n)));
    }), jr = F2(function(e, n) {
        return {
            $: 4,
            a: e,
            b: n
        };
    }), zr = function(e) {
        return {
            $: 3,
            a: e
        };
    }, Ar = function(e) {
        return {
            $: 0,
            a: e
        };
    }, Sr = {
        $: 2
    }, Tr = {
        $: 1
    }, Lr = {
        $: -2
    }, Nr = Lr, Cr = function(e) {
        return !e.$;
    }, Er = function(e) {
        return 1 === e.$;
    }, qr = f, Or = F2(function(e, n) {
        e: for(;;){
            if (-2 === n.$) return Rn;
            var t = n.c, r = n.d, a = n.e;
            switch(A2(qr, e, n.b)){
                case 0:
                    n = r;
                    continue e;
                case 1:
                    return Pn(t);
                default:
                    n = a;
                    continue e;
            }
        }
    }), Ir = F5(function(e, n, t, r, a) {
        return {
            $: -1,
            a: e,
            b: n,
            c: t,
            d: r,
            e: a
        };
    }), Pr = F5(function(e, n, t, r, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== r.$ || r.a || -1 !== r.d.$ || r.d.a) return A5(Ir, e, n, t, r, a);
            var i = r.d;
            return u = r.e, A5(Ir, 0, r.b, r.c, A5(Ir, 1, i.b, i.c, i.d, i.e), A5(Ir, 1, n, t, u, a));
        }
        var u, o = a.b, c = a.c, s = a.d, f = a.e;
        return -1 !== r.$ || r.a ? A5(Ir, e, o, c, A5(Ir, 0, n, t, r, s), f) : A5(Ir, 0, n, t, A5(Ir, 1, r.b, r.c, r.d, u = r.e), A5(Ir, 1, o, c, s, f));
    }), Rr = F3(function(e, n, t) {
        if (-2 === t.$) return A5(Ir, 0, e, n, Lr, Lr);
        var r = t.a, a = t.b, i = t.c, u = t.d, o = t.e;
        switch(A2(qr, e, a)){
            case 0:
                return A5(Pr, r, a, i, A3(Rr, e, n, u), o);
            case 1:
                return A5(Ir, r, a, n, u, o);
            default:
                return A5(Pr, r, a, i, u, A3(Rr, e, n, o));
        }
    }), Xr = F3(function(e, n, t) {
        var r = A3(Rr, e, n, t);
        return -1 !== r.$ || r.a ? r : A5(Ir, 1, r.b, r.c, r.d, r.e);
    }), Fr = function(e) {
        if (-1 === e.$ && -1 === e.d.$ && -1 === e.e.$) {
            if (-1 !== e.e.d.$ || e.e.d.a) {
                var n = e.d, t = e.e;
                return u = t.b, o = t.c, r = t.d, f = t.e, A5(Ir, 1, e.b, e.c, A5(Ir, 0, n.b, n.c, n.d, n.e), A5(Ir, 0, u, o, r, f));
            }
            var r, a = e.d, i = e.e, u = i.b, o = i.c, c = (r = i.d).d, s = r.e, f = i.e;
            return A5(Ir, 0, r.b, r.c, A5(Ir, 1, e.b, e.c, A5(Ir, 0, a.b, a.c, a.d, a.e), c), A5(Ir, 1, u, o, s, f));
        }
        return e;
    }, Jr = function(e) {
        if (-1 === e.$ && -1 === e.d.$ && -1 === e.e.$) {
            if (-1 !== e.d.d.$ || e.d.d.a) {
                var n = e.d, t = e.e;
                return s = t.b, f = t.c, l = t.d, h = t.e, A5(Ir, 1, r = e.b, a = e.c, A5(Ir, 0, n.b, n.c, n.d, o = n.e), A5(Ir, 0, s, f, l, h));
            }
            var r = e.b, a = e.c, i = e.d, u = i.d, o = i.e, c = e.e, s = c.b, f = c.c, l = c.d, h = c.e;
            return A5(Ir, 0, i.b, i.c, A5(Ir, 1, u.b, u.c, u.d, u.e), A5(Ir, 1, r, a, o, A5(Ir, 0, s, f, l, h)));
        }
        return e;
    }, Dr = F7(function(e, n, t, r, a, i, u) {
        if (-1 !== i.$ || i.a) {
            e: for(;;){
                if (-1 === u.$ && 1 === u.a) {
                    if (-1 === u.d.$) {
                        if (1 === u.d.a) return Jr(n);
                        break e;
                    }
                    return Jr(n);
                }
                break e;
            }
            return n;
        }
        return A5(Ir, t, i.b, i.c, i.d, A5(Ir, 0, r, a, i.e, u));
    }), Ur = function(e) {
        if (-1 === e.$ && -1 === e.d.$) {
            var n = e.a, t = e.b, r = e.c, a = e.d, i = a.d, u = e.e;
            if (1 === a.a) {
                if (-1 !== i.$ || i.a) {
                    var o = Fr(e);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(Pr, o.a, o.b, o.c, Ur(o.d), c);
                    }
                    return Lr;
                }
                return A5(Ir, n, t, r, Ur(a), u);
            }
            return A5(Ir, n, t, r, Ur(a), u);
        }
        return Lr;
    }, Kr = F2(function(e, n) {
        if (-2 === n.$) return Lr;
        var t = n.a, r = n.b, a = n.c, i = n.d, u = n.e;
        if (0 > s(e, r)) {
            if (-1 === i.$ && 1 === i.a) {
                var o = i.d;
                if (-1 !== o.$ || o.a) {
                    var c = Fr(n);
                    if (-1 === c.$) {
                        var f = c.e;
                        return A5(Pr, c.a, c.b, c.c, A2(Kr, e, c.d), f);
                    }
                    return Lr;
                }
                return A5(Ir, t, r, a, A2(Kr, e, i), u);
            }
            return A5(Ir, t, r, a, A2(Kr, e, i), u);
        }
        return A2(Br, e, A7(Dr, e, n, t, r, a, i, u));
    }), Br = F2(function(e, n) {
        if (-1 === n.$) {
            var t = n.a, r = n.b, a = n.c, u = n.d, o = n.e;
            if (i(e, r)) {
                var c = function(e) {
                    for(;;){
                        if (-1 !== e.$ || -1 !== e.d.$) return e;
                        e = e.d;
                    }
                }(o);
                return -1 === c.$ ? A5(Pr, t, c.b, c.c, u, Ur(o)) : Lr;
            }
            return A5(Pr, t, r, a, u, A2(Kr, e, o));
        }
        return Lr;
    }), Gr = F2(function(e, n) {
        var t = A2(Kr, e, n);
        return -1 !== t.$ || t.a ? t : A5(Ir, 1, t.b, t.c, t.d, t.e);
    }), Hr = F3(function(e, n, t) {
        var r = n(A2(Or, e, t));
        return r.$ ? A2(Gr, e, t) : A3(Xr, e, r.a, t);
    }), Mr = F2(function(e, n) {
        return A2(_r, e, A2(gn, n, Rn));
    }), Wr = F2(function(e, n) {
        return A2(Mr, A2(ir, e, kr), n);
    }), Yr = F2(function(e, n) {
        return {
            $: 1,
            a: e,
            b: n
        };
    }), Qr = function(e) {
        return A2(Yr, "application/json", A2(Fn, 0, e));
    }, Vr = function(e) {
        return A3(Bn, F2(function(e, n) {
            return A3(V, e.a, e.b, n);
        }), {}, e);
    }, Zr = function(e) {
        return {
            $: 0,
            b: "text",
            a: function(n) {
                var t = A2(wr, e, n.bD);
                return 1 === t.$ ? Nn(rt(t.a)) : On(t.a);
            }
        };
    }, ea = Et, na = F3(function(e, n, t) {
        return ea({
            bD: n,
            aR: Zr(t),
            aX: g,
            b5: "POST",
            bq: Rn,
            aE: e,
            cJ: !1
        });
    }), ta = Y, ra = function(e) {
        return A2(Wr, ar, function(e) {
            var n = Vr($([
                l("operation", ta("wake"))
            ]));
            return A3(na, e.w, Qr(n), Nt(0));
        }(e));
    }, aa = function(e) {
        return {
            $: 2,
            a: e
        };
    }, ia = function(e) {
        return {
            $: 26,
            a: e
        };
    }, ua = function(e) {
        return {
            $: 24,
            a: e
        };
    }, oa = $e, ca = F2(function(e, n) {
        return {
            $: 0,
            a: e,
            b: n
        };
    }), sa = F2(function(e, n) {
        return {
            be: n,
            bp: e
        };
    }), fa = Pt(A2(sa, Nr, Nr)), la = F2(function(e, n) {
        var t = e.a, r = e.b, a = A2(Or, t, n);
        return A3(Xr, t, 1 === a.$ ? $([
            r
        ]) : A2(jn, r, a.a), n);
    }), ha = F3(function(e, n, t) {
        for(;;){
            if (-2 === t.$) return n;
            var r = t.e, a = e, i = A3(e, t.b, t.c, A3(ha, e, n, t.d));
            e = a, n = i, t = r;
        }
    }), ba = F6(function(e, n, t, r, a, i) {
        var u = A3(ha, F3(function(r, a, i) {
            e: for(;;){
                var u = i.a, o = i.b;
                if (u.b) {
                    var c = u.a, f = c.a, h = c.b, b = u.b;
                    if (0 > s(f, r)) {
                        i = l(b, A3(e, f, h, o));
                        continue e;
                    }
                    return s(f, r) > 0 ? l(u, A3(t, r, a, o)) : l(b, A4(n, f, h, a, o));
                }
                return l(u, A3(t, r, a, o));
            }
        }), l(An(r), i), a), o = u.a, c = u.b;
        return A3(Bn, F2(function(n, t) {
            return A3(e, n.a, n.b, t);
        }), c, o);
    }), pa = ve, da = dn, ga = ue, va = F3(function(e, n, t) {
        if (n.b) {
            var r = n.a, a = n.b, i = ga(A2(da, r, A2(pa, e, r)));
            return A2(Dt, function(n) {
                return A3(va, e, a, A3(Xr, r, n, t));
            }, i);
        }
        return Pt(t);
    });
    be.Time = pe(fa, F3(function(e, n, t) {
        var r = t.be, a = F3(function(e, n, t) {
            var r, a = t.c;
            return h(t.a, t.b, A2(Dt, function() {
                return a;
            }, (r = n, ne(function(e) {
                var n = r.f;
                2 === n.$ && n.c && n.c(), r.f = null, e(Z(0));
            }))));
        }), i = A3(Bn, la, Nr, n), u = A6(ba, F3(function(e, n, t) {
            var r = t.b, a = t.c;
            return h(A2(jn, e, t.a), r, a);
        }), F4(function(e, n, t, r) {
            var a = r.c;
            return h(r.a, A3(Xr, e, t, r.b), a);
        }), a, i, r, h(g, Nr, Pt(0))), o = u.a, c = u.b;
        return A2(Dt, function(e) {
            return Pt(A2(sa, i, e));
        }, A2(Dt, function() {
            return A3(va, e, o, c);
        }, u.c));
    }), F3(function(e, n, t) {
        var r = A2(Or, n, t.bp);
        if (1 === r.$) return Pt(t);
        var a = r.a;
        return A2(Dt, function() {
            return Pt(t);
        }, A2(Dt, function(n) {
            return Bt(A2(Jt, function(t) {
                return A2(Gt, e, t(n));
            }, a));
        }, rr));
    }), 0, F2(function(e, n) {
        return A2(ca, n.a, A2(ir, e, n.b));
    }));
    var ma, $a, ya, wa = me("Time"), ka = F2(function(e, n) {
        return wa(A2(ca, e, n));
    }), xa = oa(g), _a = (ma = "savedGames", $a = $r(A2(St, function(e) {
        return A2(St, function(n) {
            return A2(St, function(t) {
                return A2(St, function(r) {
                    return A2(St, function(a) {
                        return Nt({
                            aU: a,
                            at: r,
                            cm: t,
                            ac: n,
                            cx: e
                        });
                    }, A2(Vt, "gameId", vr));
                }, A2(Vt, "gameName", vr));
            }, A2(Vt, "playerKey", vr));
        }, A2(Vt, "screenName", vr));
    }, A2(Vt, "startTime", N))), je(ma), be[ma] = {
        f: Te,
        u: $a,
        a: function(e, n) {
            var t = g, r = be[e].u, i = Z(null);
            return be[e].b = i, be[e].c = F3(function(e, n) {
                return t = n, i;
            }), {
                send: function(e) {
                    var i = A2(J, r, e);
                    At(i) || a(4);
                    for(var u = i.a, o = t; o.b; o = o.b)n(o.a(u));
                }
            };
        }
    }, me(ma)), ja = F2(function(e, n) {
        return {
            $: 13,
            a: e,
            b: n
        };
    }), za = {
        $: 10
    }, Aa = function(e) {
        return {
            $: 12,
            a: e
        };
    }, Sa = function(e) {
        return {
            $: 1,
            a: e
        };
    }, Ta = F2(function(e, n) {
        return {
            $: 2,
            a: e,
            b: n
        };
    }), La = function(e) {
        return {
            $: 14,
            a: e
        };
    }, Na = function(e) {
        return {
            $: 3,
            a: e
        };
    }, Ca = F3(function(e, n, t) {
        return {
            $: 8,
            a: e,
            b: n,
            c: t
        };
    }), Ea = {
        $: 11
    }, qa = F2(function(e, n) {
        return {
            $: 7,
            a: e,
            b: n
        };
    }), Oa = {
        $: 6
    }, Ia = {
        $: 4
    }, Pa = function(e) {
        return {
            $: 22,
            a: e
        };
    }, Ra = F4(function(e, n, t, r) {
        return {
            ck: t,
            ct: r,
            cy: n,
            cz: e
        };
    }), Xa = C, Fa = F7(function(e, n, t, r, a, i, u) {
        return {
            bN: a,
            aU: e,
            at: n,
            bX: r,
            bb: u,
            bj: i,
            ac: t
        };
    }), Ja = A3(gr, "points", $r(vr), A3(gr, "role", (ya = vr, hr($([
        lr(Rn),
        A2(Tt, Pn, ya)
    ]))), A3(gr, "discardedWords", $r(vr), A3(gr, "hand", $r(vr), A3(gr, "screenName", vr, A3(gr, "gameName", vr, A3(gr, "gameId", vr, Nt(Fa)))))))), Da = F2(function(e, n) {
        return {
            bb: n,
            ac: e
        };
    }), Ua = A3(gr, "points", $r(vr), A3(gr, "screenName", vr, Nt(Da))), Ka = F3(function(e, n, t) {
        return {
            bF: e,
            cn: t,
            bj: n
        };
    }), Ba = function(e) {
        return A3(Bn, F2(function(e, n) {
            return A3(Xr, e.a, e.b, n);
        }), Nr, e);
    }, Ga = A3(gr, "products", function(e) {
        return A2(Tt, Ba, function(e) {
            return {
                $: 8,
                b: e
            };
        }(e));
    }($r(vr)), A3(gr, "role", vr, A3(gr, "buyer", vr, Nt(Ka)))), Ha = A4(dr, "round", A2(Tt, Pn, Ga), Rn, A3(gr, "opponents", $r(Ua), A3(gr, "started", Xa, A3(gr, "state", Ja, Nt(Ra))))), Ma = F5(function(e, n, t, r, a) {
        var i = Vr($([
            l("operation", ta("award-point")),
            l("playerKey", ta(t)),
            l("gameId", ta(n)),
            l("role", ta(r)),
            l("awardToPlayerWithName", ta(a))
        ]));
        return A3(na, e.w, Qr(i), Ha);
    }), Wa = F5(function(e, n, t, r, a) {
        return A2(Wr, Pa, A5(Ma, e, n, t, r, a));
    }), Ya = function(e) {
        return {
            $: 18,
            a: e
        };
    }, Qa = F3(function(e, n, t) {
        var r = Vr($([
            l("operation", ta("become-buyer")),
            l("playerKey", ta(t)),
            l("gameId", ta(n))
        ]));
        return A3(na, e.w, Qr(r), Ha);
    }), Va = F3(function(e, n, t) {
        return A2(Wr, Ya, A3(Qa, e, n, t));
    }), Za = F3(function(e, n, t) {
        return {
            $: 9,
            a: e,
            b: n,
            c: t
        };
    }), ei = A3(gr, "gameCode", vr, A3(gr, "playerKey", vr, A3(gr, "state", Ja, Nt(F3(function(e, n, t) {
        return {
            aT: t,
            cm: n,
            cz: e
        };
    }))))), ni = F3(function(e, n, t) {
        var r = Vr($([
            l("operation", ta("create-game")),
            l("screenName", ta(t)),
            l("gameName", ta(n))
        ]));
        return A3(na, e.w, Qr(r), ei);
    }), ti = F3(function(e, n, t) {
        return A2(Wr, A2(Za, n, t), A3(ni, e, n, t));
    }), ri = F2(function(e, n) {
        return A3(Ft, F2(function(n, t) {
            return e(n) ? A2(jn, n, t) : t;
        }), g, n);
    }), ai = function(e) {
        return {
            $: 29,
            a: e
        };
    }, ii = F2(function(e, n) {
        return A3(Bn, function(e) {
            return F2(function(n, t) {
                return t.push(e(n)), t;
            });
        }(e), [], n);
    }), ui = F4(function(e, n, t, r) {
        var a = r.a, i = r.b, u = Vr($([
            l("operation", ta("finish-pitch")),
            l("playerKey", ta(t)),
            l("gameId", ta(n)),
            l("words", A2(ii, ta, $([
                a,
                i
            ])))
        ]));
        return A3(na, e.w, Qr(u), Ha);
    }), oi = F4(function(e, n, t, r) {
        return A2(Wr, ai, A4(ui, e, n, t, r));
    }), ci = F3(function(e, n, t) {
        return {
            $: 10,
            a: e,
            b: n,
            c: t
        };
    }), si = A3(gr, "playerKey", vr, A3(gr, "state", Ja, Nt(F2(function(e, n) {
        return {
            cm: n,
            cz: e
        };
    })))), fi = F3(function(e, n, t) {
        var r = Vr($([
            l("operation", ta("register-player")),
            l("screenName", ta(t)),
            l("gameCode", ta(n))
        ]));
        return A3(na, e.w, Qr(r), si);
    }), li = F3(function(e, n, t) {
        return A2(Wr, A2(ci, n, t), A3(fi, e, n, t));
    }), hi = F3(function(e, n, t) {
        return 1 === n.$ || 1 === t.$ ? Rn : Pn(A2(e, n.a, t.a));
    }), bi = function(e) {
        return A3(hi, function(e) {
            return function(n) {
                return l(e.aU, n);
            };
        }, e.cz, e.cm);
    }, pi = function(e) {
        return {
            $: 25,
            a: e
        };
    }, di = F3(function(e, n, t) {
        var r = Vr($([
            l("operation", ta("lobby-ping")),
            l("playerKey", ta(t)),
            l("gameId", ta(n))
        ]));
        return A3(na, e.w, Qr(r), Ha);
    }), gi = F3(function(e, n, t) {
        return A2(Wr, pi, A3(di, e, n, t));
    }), vi = c, mi = nr(g), $i = function(e) {
        return {
            $: 23,
            a: e
        };
    }, yi = F3(function(e, n, t) {
        var r = Vr($([
            l("operation", ta("ping")),
            l("playerKey", ta(t)),
            l("gameId", ta(n))
        ]));
        return A3(na, e.w, Qr(r), Ha);
    }), wi = F3(function(e, n, t) {
        return A2(Wr, $i, A3(yi, e, n, t));
    }), ki = function(e) {
        return {
            $: 20,
            a: e
        };
    }, xi = F3(function(e, n, t) {
        var r = Vr($([
            l("operation", ta("relinquish-buyer")),
            l("playerKey", ta(t)),
            l("gameId", ta(n))
        ]));
        return A3(na, e.w, Qr(r), Ha);
    }), _i = F3(function(e, n, t) {
        return A2(Wr, ki, A3(xi, e, n, t));
    }), ji = Y, zi = ze("removeSavedGame", function(e) {
        return Vr($([
            l("gameId", ta(e.aU)),
            l("gameName", ta(e.at)),
            l("playerKey", ta(e.cm)),
            l("screenName", ta(e.ac)),
            l("startTime", ji(e.cx))
        ]));
    }), Ai = F2(function(e, n) {
        return n.$ ? Rn : Pn(e(n.a));
    }), Si = F6(function(e, n, t, r, a, i) {
        return 1 === n.$ || 1 === t.$ || 1 === r.$ || 1 === a.$ || 1 === i.$ ? Rn : Pn(A5(e, n.a, t.a, r.a, a.a, i.a));
    }), Ti = ze("sendGameToJS", function(e) {
        return Vr($([
            l("gameId", ta(e.aU)),
            l("gameName", ta(e.at)),
            l("playerKey", ta(e.cm)),
            l("screenName", ta(e.ac)),
            l("startTime", ji(e.cx))
        ]));
    }), Li = F5(function(e, n, t, r, a) {
        return Ti({
            aU: e,
            at: n,
            cm: t,
            ac: r,
            cx: a
        });
    }), Ni = F2(function(e, n) {
        return n.$ ? e : n.a;
    }), Ci = function(e) {
        return A2(Ni, mi, A6(Si, Li, A2(Ai, function(e) {
            return e.aU;
        }, e.cz), A2(Ai, function(e) {
            return e.at;
        }, e.cz), e.cm, A2(Ai, function(e) {
            return e.ac;
        }, e.cz), Pn(e.cE)));
    }, Ei = F2(function(e, n) {
        return {
            $: 14,
            a: e,
            b: n
        };
    }), qi = F3(function(e, n, t) {
        var r = Vr($([
            l("operation", ta("start-game")),
            l("playerKey", ta(t)),
            l("gameId", ta(n))
        ]));
        return A3(na, e.w, Qr(r), Ha);
    }), Oi = F4(function(e, n, t, r) {
        return A2(Wr, Ei(n), A3(qi, e, t, r));
    }), Ii = F2(function(e, n) {
        switch(e.$){
            case 3:
                return l(p(n, {
                    b0: !1,
                    b4: Zt,
                    ck: g,
                    cm: Rn,
                    ct: Rn,
                    cz: Rn
                }), tr(0));
            case 1:
                return l(p(n, {
                    cE: e.a
                }), tr(0));
            case 4:
                return l(p(n, {
                    b4: A2(qa, g, g)
                }), mi);
            case 0:
                return l(p(n, {
                    bA: !0
                }), mi);
            case 2:
                return l(p(n, {
                    cv: e.a
                }), mi);
            case 5:
                return l(p(n, {
                    b4: Sa({
                        aP: P = e.c,
                        at: t = e.a,
                        a2: !1,
                        ac: a = e.b
                    })
                }), mi);
            case 6:
                return l(p(n, {
                    b4: Sa({
                        aP: g,
                        at: t = e.a,
                        a2: !0,
                        ac: a = e.b
                    })
                }), A3(ti, n, t, a));
            case 7:
                return l(p(n, {
                    b4: Na({
                        aP: P = e.c,
                        aT: d = e.a,
                        a2: !1,
                        ac: a = e.b
                    })
                }), mi);
            case 8:
                return l(p(n, {
                    b4: Na({
                        aP: g,
                        aT: d = e.a,
                        a2: !0,
                        ac: a = e.b
                    })
                }), A3(li, n, d, a));
            case 9:
                var t;
                if (1 === e.c.$) return l(p(n, {
                    b4: Sa({
                        aP: P = e.c.a,
                        at: t = e.a,
                        a2: !1,
                        ac: a = e.b
                    })
                }), mi);
                var r = e.c.a;
                return l(p(n, {
                    b0: !0,
                    b4: A2(Ta, r.aT, g),
                    ck: g,
                    cm: Pn(r.cm),
                    ct: Rn,
                    cz: Pn(r.cz)
                }), mi);
            case 10:
                var a;
                if (1 === e.c.$) return l(p(n, {
                    b4: Na({
                        aP: P = e.c.a,
                        aT: s = e.a,
                        a2: !1,
                        ac: a = e.b
                    })
                }), mi);
                var u = e.c.a;
                return l(p(n, {
                    b0: !1,
                    b4: Ia,
                    cm: Pn(u.cm),
                    cz: Pn(u.cz)
                }), mi);
            case 11:
                var o = {
                    bN: g,
                    aU: (c = e.a).aU,
                    at: c.at,
                    bX: g,
                    bb: g,
                    bj: Rn,
                    ac: c.ac
                };
                return l(p(n, {
                    b4: (K = c, {
                        $: 5,
                        a: K
                    }),
                    cm: Pn(c.cm),
                    cz: Pn(o)
                }), A3(wi, n, c.aU, c.cm));
            case 12:
                var c;
                return l(n, zi(c = e.a));
            case 13:
                var s = e.a, f = bi(n);
                if (f.$) {
                    var h = $([
                        {
                            X: Rn,
                            aa: "Could not start game"
                        }
                    ]);
                    return l(p(n, {
                        b4: A2(Ta, s, h)
                    }), mi);
                }
                var b = f.a, d = b.a, v = b.b;
                return l(p(n, {
                    b4: Oa
                }), A4(Oi, n, s, d, v));
            case 14:
                if (1 === e.b.$) return l(p(n, {
                    b4: A2(Ta, s = e.a, P = e.b.a)
                }), mi);
                var m = e.b.a;
                return l(q = p(n, {
                    b4: A2(qa, g, g),
                    ck: m.ck,
                    ct: m.ct,
                    cz: Pn(m.cz)
                }), Ci(q));
            case 15:
                var y = e.a, w = (k = e.b).b ? k.b.b ? k : $([
                    k.a,
                    y
                ]) : $([
                    y
                ]);
                return l(p(n, {
                    b4: A2(qa, w, g)
                }), mi);
            case 16:
                var k, x = e.a;
                return l(p(n, {
                    b4: A2(qa, w = A2(ri, function(e) {
                        return !i(e, x);
                    }, k = e.b), g)
                }), mi);
            case 17:
                var _ = bi(n);
                if (_.$) return l(p(n, {
                    b4: La($([
                        "No player key or game ID"
                    ]))
                }), mi);
                var j = _.a;
                return d = j.a, v = j.b, l(p(n, {
                    b4: za
                }), A3(Va, n, d, v));
            case 18:
                return l(p(n, 1 === e.a.$ ? {
                    b4: A2(qa, g, P = e.a.a)
                } : {
                    b4: Aa(A2(Ni, "Couldn't get a role", (m = e.a.a).cz.bj)),
                    ck: m.ck,
                    ct: m.ct,
                    cz: Pn(m.cz)
                }), mi);
            case 19:
                var z = bi(n);
                if (z.$) return l(p(n, {
                    b4: La($([
                        "No player key or game ID"
                    ]))
                }), mi);
                var A = z.a;
                return d = A.a, v = A.b, l(p(n, {
                    b4: Ea
                }), A3(_i, n, d, v));
            case 20:
                return 1 === e.a.$ ? l(p(n, {
                    b4: A2(qa, g, P = e.a.a)
                }), mi) : (m = e.a.a, l(p(n, {
                    b4: A2(qa, g, g),
                    ck: m.ck,
                    ct: m.ct,
                    cz: Pn(m.cz)
                }), mi));
            case 21:
                var S = e.a, T = e.b, L = bi(n);
                if (L.$) return l(p(n, {
                    b4: La($([
                        "No game ID or Player Key"
                    ]))
                }), mi);
                var N = L.a;
                return d = N.a, v = N.b, l(p(n, {
                    b4: A2(ja, S, T)
                }), A5(Wa, n, d, v, S, T));
            case 22:
                return 1 === e.a.$ ? l(p(n, {
                    b4: La(A2(Jt, function(e) {
                        return e.aa;
                    }, e.a.a))
                }), mi) : (m = e.a.a, l(p(n, {
                    b4: A2(qa, g, g),
                    ck: m.ck,
                    ct: m.ct,
                    cz: Pn(m.cz)
                }), mi));
            case 24:
                var C = bi(n);
                if (C.$) return l(n, mi);
                var E = C.a;
                return l(n, A3(wi, n, d = E.a, v = E.b));
            case 23:
                if (1 === e.a.$) return l(n, mi);
                switch(m = e.a.a, n.b4.$){
                    case 4:
                        var q;
                        return m.cy ? l(q = p(n, {
                            b4: A2(qa, g, g),
                            ck: m.ck,
                            ct: m.ct,
                            cz: Pn(m.cz)
                        }), Ci(q)) : l(p(n, {
                            ck: m.ck,
                            ct: m.ct,
                            cz: Pn(m.cz)
                        }), mi);
                    case 5:
                        return l(p(n, {
                            b4: (U = m.cz.bj).$ ? A2(qa, g, g) : Aa(U.a),
                            ck: m.ck,
                            ct: m.ct,
                            cz: Pn(m.cz)
                        }), mi);
                    default:
                        return l(p(n, {
                            ck: m.ck,
                            ct: m.ct,
                            cz: Pn(m.cz)
                        }), mi);
                }
            case 26:
                var O = bi(n);
                if (O.$) return l(n, mi);
                var I = O.a;
                return l(n, A3(gi, n, d = I.a, v = I.b));
            case 25:
                if (1 === e.a.$) {
                    var P = e.a.a, R = n.b4;
                    return l(2 === R.$ ? p(n, {
                        b4: A2(Ta, s = R.a, P)
                    }) : n, mi);
                }
                return m = e.a.a, l(2 === n.b4.$ ? p(n, {
                    ck: m.ck,
                    cz: Pn(m.cz)
                }) : n, mi);
            case 27:
                return l(p(n, {
                    b4: A3(Ca, X = e.a, F = e.b, !1)
                }), mi);
            case 28:
                var X = e.a, F = e.b, J = bi(n);
                if (J.$) return l(n, mi);
                var D = J.a;
                return d = D.a, v = D.b, l(p(n, {
                    b4: A3(Ca, X, F, !0)
                }), A4(oi, n, d, v, l(X, F)));
            default:
                return 1 === e.a.$ ? l(p(n, {
                    b4: La(A2(Jt, function(e) {
                        return e.aa;
                    }, e.a.a))
                }), mi) : (m = e.a.a, l(p(n, {
                    b4: A2(qa, g, g),
                    ck: m.ck,
                    ct: m.ct,
                    cz: Pn(m.cz)
                }), mi));
        }
        var U, K;
    }), Pi = qe("a"), Ri = F2(function(e, n) {
        return A2(Pe, e, ta(n));
    }), Xi = Ri("alt"), Fi = Ri("className"), Ji = F2(function(e, n) {
        return {
            $: 0,
            a: e,
            b: n
        };
    }), Di = {
        $: 19
    }, Ui = qe("button"), Ki = qe("div"), Bi = function(e) {
        return A2(Ki, $([
            Fi("card-panel")
        ]), e);
    }, Gi = F2(function(e, n) {
        return A2(Ki, $([
            Fi("col " + e)
        ]), n);
    }), Hi = F2(function(e, n) {
        return A2(Ki, $([
            Fi("container " + e)
        ]), n);
    }), Mi = Ee, Wi = Mi(""), Yi = function(e) {
        var n = e.replace(/^\s+/, "");
        return A2(It, "|", n) ? A2(Ot, 1, n) : e;
    }, Qi = mn({
        aM: Rn,
        bW: Pn({
            bE: !1,
            cC: !1
        }),
        cu: !0,
        cw: !1
    }), Vi = function(e) {
        return A2(Qi, $([
            Fi("text--help")
        ]), A2(Dn, "\n", A2(Jt, Yi, A2(Un, "\n", e))));
    }, Zi = qe("i"), eu = F2(function(e, n) {
        return A2(Zi, $([
            Fi("material-icons " + n)
        ]), $([
            Mi(e)
        ]));
    }), nu = Ie, tu = F2(function(e, n) {
        return A2(nu, e, {
            $: 0,
            a: n
        });
    }), ru = function(e) {
        return A2(tu, "click", Nt(e));
    }, au = function(e) {
        return !e.b;
    }, iu = F2(function(e, n) {
        return {
            $: 21,
            a: e,
            b: n
        };
    }), uu = Y, ou = F2(function(e, n) {
        return A2(Pe, e, uu(n));
    })("disabled"), cu = qe("li"), su = F2(function(e, n) {
        return !A2(Or, e, n).$;
    }), fu = function(e) {
        return !e;
    }, lu = qe("p"), hu = F3(function(e, n, t) {
        var r = A2(Ni, g, A2(Or, t.ac, n)), a = au(r) ? "Not yet pitched" : A2(Dn, " ", r), i = A2(su, t.ac, n);
        return A2(cu, $([
            Fi("awards__li valign-wrapper")
        ]), $([
            A2(Ki, $([
                Fi("award-name__container left valign-wrapper")
            ]), $([
                A2(lu, g, $([
                    Mi(t.ac)
                ]))
            ])),
            A2(Ki, $([
                Fi("award-winner__container left")
            ]), $([
                A2(Ui, $([
                    Fi("award-winner__button waves-effect waves-light btn purple btn-large"),
                    ru(A2(iu, e, t.ac)),
                    ou(!i)
                ]), $([
                    Mi(a),
                    A2(eu, "favorite", "right")
                ]))
            ]))
        ]));
    }), bu = qe("ul"), pu = F3(function(e, n, t) {
        return au(e) ? A2(Ki, g, $([
            Vi("There are no other players in this game so there's no one to award the point to."),
            A2(lu, g, $([
                A2(Ui, $([
                    Fi("waves-effect waves-light btn blue"),
                    ru(Di)
                ]), $([
                    A2(eu, "close", "left"),
                    Mi("Cancel")
                ]))
            ]))
        ])) : A2(bu, $([
            Fi("awards__list")
        ]), A2(Jt, A2(hu, t, n), e));
    }), du = function(e) {
        return A2(Ki, $([
            Fi("row")
        ]), e);
    }, gu = qe("span"), vu = F3(function(e, n, t) {
        var r = function() {
            if (1 === n.$) return A2(Ji, !1, $([
                Wi
            ]));
            var t = n.a;
            return A2(Ji, !0, $([
                Mi("Awarding "),
                Mi(e),
                Mi(" to "),
                Mi(t)
            ]));
        }(), a = A2(Ni, Nr, A2(Ai, function(e) {
            return e.cn;
        }, t.ct));
        return h($([
            A2(Ui, $([
                Fi("waves-effect waves-light btn blue"),
                ru(Di)
            ]), $([
                A2(eu, "close", "left"),
                Mi("Cancel")
            ]))
        ]), r, A2(Hi, "buying", $([
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        A2(gu, $([
                            Fi("buyer-role__text")
                        ]), $([
                            Mi(e)
                        ]))
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        Vi("|Show the rest of the players this role.\n                           |\n                           |The other players will each try to **pitch** a product to\n                           |you as that role.\n                           |\n                           |After they've each had a turn pitching their product,\n                           |choose the player whose sales pitch & end product you\n                           |most liked from the list below.\n                           |")
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        A3(pu, t.ck, a, e)
                    ]))
                ]))
            ]))
        ])));
    }), mu = F2(function(e, n) {
        return {
            $: 6,
            a: e,
            b: n
        };
    }), $u = F3(function(e, n, t) {
        return {
            $: 5,
            a: e,
            b: n,
            c: t
        };
    }), yu = {
        $: 3
    }, wu = F3(function(e, n, t) {
        return n(e(t));
    }), ku = F2(function(e, n) {
        return A2(ri, A2(wu, function(e) {
            return e.X;
        }, A2(wu, Ni(""), vi(e))), n);
    }), xu = F2(function(e, n) {
        return A2(ri, A2(wu, function(e) {
            return e.X;
        }, A2(wu, Ni(""), dt(e))), n);
    }), _u = qe("form"), ju = F3(function(e, n, t) {
        return A2(e, t, n);
    }), zu = F2(function(e, n) {
        for(;;){
            if (!n.b) return !1;
            var t = n.b;
            if (e(n.a)) return !0;
            n = t;
        }
    }), Au = F2(function(e, n) {
        return A2(zu, function(n) {
            return i(n, e);
        }, n);
    }), Su = F2(function(e, n) {
        return A2(ri, A2(wu, function(e) {
            return e.X;
        }, A2(wu, Ni(""), A2(wu, A2(ju, Au, e), fu))), n);
    }), Tu = function(e) {
        return l(e, !0);
    }, Lu = F2(function(e, n) {
        return A2(nu, e, {
            $: 1,
            a: n
        });
    }), Nu = A2(sr, $([
        "target",
        "value"
    ]), vr), Cu = function(e) {
        return A2(Lu, "input", A2(Tt, Tu, A2(Tt, e, Nu)));
    }, Eu = function(e) {
        return l(e, !0);
    }, qu = F2(function(e, n) {
        return A2(nu, e, {
            $: 2,
            a: n
        });
    }), Ou = function(e) {
        return A2(qu, "submit", A2(Tt, Eu, Nt(e)));
    }, Iu = function(e) {
        return A2(Dn, "", e);
    }, Pu = F2(function(e, n) {
        if (n.b) {
            var t = n.b;
            return A2(jn, n.a, A3(Ft, F2(function(n, t) {
                return A2(jn, e, A2(jn, n, t));
            }), g, t));
        }
        return g;
    }), Ru = function(e) {
        return au(e) ? Mi("") : A2(Ki, $([
            Fi("card-panel red lighten-4")
        ]), $([
            Mi(Iu(A2(Pu, ", ", A2(Jt, function(e) {
                return e.aa;
            }, e))))
        ]));
    }, Xu = F2(function(e, n) {
        return A2(Re, function(e) {
            return Xe.test(e) ? "data-" + e : e;
        }(e), Je(n));
    }), Fu = function(e) {
        return e.b;
    }, Ju = function(e) {
        return Fi(A2(Dn, " ", A2(Jt, kt, A2(ri, Fu, e))));
    }, Du = Ri("htmlFor"), Uu = Ri("id"), Ku = qe("input"), Bu = qe("label"), Gu = Ri("name"), Hu = Ri("type"), Mu = F5(function(e, n, t, r, a) {
        var i, u = !au(r), o = Iu(A2(Pu, ", ", A2(Jt, function(e) {
            return e.aa;
        }, r))), c = n + "-id", s = $([
            Uu(c),
            Gu(n),
            Hu("text"),
            A2(Ri, "autocomplete", "off"),
            Ju($([
                l("invalid", u)
            ]))
        ]);
        return A2(Ki, $([
            Fi("input-field")
        ]), $([
            A2(Ku, d(s, a), g),
            A2(Bu, $([
                Du(c),
                Ju($([
                    l("active", (i = t, !("" === i)))
                ]))
            ]), $([
                Mi(e)
            ])),
            A2(gu, $([
                Fi("helper-text"),
                A2(Xu, "data-error", o)
            ]), g)
        ]));
    }), Wu = F5(function(e, n, t, r) {
        return h($([
            A2(Ui, $([
                Fi("waves-effect waves-light btn green"),
                ru(yu)
            ]), $([
                A2(eu, "home", "left"),
                Mi("back")
            ]))
        ]), A2(Ji, e, $([
            Mi("Creating game")
        ])), A2(Hi, "create", $([
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        Ru(A2(Su, $([
                            "game name",
                            "screen name"
                        ]), r)),
                        A2(_u, $([
                            Ou(A2(mu, n, t))
                        ]), $([
                            A5(Mu, "Game name", "create-game", n, A2(xu, "game name", r), $([
                                Cu(function(e) {
                                    return A3($u, e, t, A2(ku, "game name", r));
                                })
                            ])),
                            A5(Mu, "Player name", "player-name", t, A2(xu, "screen name", r), $([
                                Cu(function(e) {
                                    return A3($u, n, e, A2(ku, "screen name", r));
                                })
                            ])),
                            A2(Ui, $([
                                Fi("waves-effect waves-light teal btn btn-large")
                            ]), $([
                                Mi("Create game"),
                                A2(eu, "gamepad", "right")
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        Vi("|Creates a new game that others can join.\n                           |You will be able to start the game when players have joined.\n                           |")
                    ]))
                ]))
            ]))
        ])));
    }), Yu = {
        $: 2
    }, Qu = function(e) {
        return A2(cu, $([
            Fi("collection-item")
        ]), $([
            A2(Ki, g, $([
                Mi(e.ac)
            ]))
        ]));
    }, Vu = Ri("value"), Zu = F3(function(e, n, t) {
        var r;
        return h(g, Yu, A2(Hi, "creator-waiting", $([
            du($([
                A2(Gi, "s12", $([
                    Ru(n),
                    Bi($([
                        du($([
                            A2(Gi, "s12 m6", $([
                                A2(Ki, $([
                                    Fi("input-field")
                                ]), $([
                                    A2(eu, "assignment", "prefix"),
                                    A2(Ku, $([
                                        Fi("game-code__input"),
                                        Uu("game-code"),
                                        Vu(e),
                                        Hu("text"),
                                        ou(!0)
                                    ]), g),
                                    A2(Bu, $([
                                        Fi("active"),
                                        Du("game-code")
                                    ]), $([
                                        Mi("Game code")
                                    ]))
                                ]))
                            ])),
                            A2(Gi, "s12 m6", $([
                                A2(gu, $([
                                    Fi("flow-text")
                                ]), $([
                                    Mi("Other players can use this code to join your game.")
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        du($([
                            A2(Gi, "s12 m6", $([
                                A2(Ki, g, $([
                                    A2(gu, $([
                                        Fi("flow-text")
                                    ]), $([
                                        Mi("Wait for other players to join before starting.")
                                    ]))
                                ]))
                            ])),
                            A2(Gi, "s12 m6", $([
                                A2(Ki, $([
                                    Fi("start-game__btn")
                                ]), $([
                                    A2(Ui, $([
                                        Fi("waves-effect waves-light blue btn btn-large cta__button"),
                                        ru((r = e, {
                                            $: 13,
                                            a: r
                                        }))
                                    ]), $([
                                        Mi("Start game"),
                                        A2(eu, "play_arrow", "right")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    A2(bu, $([
                        Fi("collection with-header z-depth-1")
                    ]), d($([
                        A2(cu, $([
                            Fi("collection-header")
                        ]), $([
                            A2(Ki, g, $([
                                A2(eu, "person", "left medium"),
                                A2(gu, $([
                                    Fi("flow-text")
                                ]), $([
                                    Mi("Players")
                                ]))
                            ]))
                        ])),
                        A2(cu, $([
                            Fi("collection-item")
                        ]), $([
                            A2(Ki, g, $([
                                Mi("You")
                            ]))
                        ]))
                    ]), A2(Jt, Qu, t.ck)))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        Vi("|You have created a new game of Quack Stanley.\n                           |Other players can join this game using the game's\n                           |code.\n                           |\n                           |Give the other players time to join and then start\n                           |the game using the button above.\n                           |\n                           |**After the game has started additional players\n                           |cannot be added.**\n                           |")
                    ]))
                ]))
            ]))
        ])));
    }), eo = qe("h1"), no = {
        $: 4
    }, to = function(e) {
        return e.cz.$ ? Mi("") : A2(Ui, $([
            Fi("waves-effect waves-light btn-flat"),
            ru(no)
        ]), $([
            A2(eu, "gamepad", "left"),
            Mi("back to game")
        ]));
    }, ro = F2(function(e, n) {
        var t;
        return h($([
            A2(Ui, $([
                Fi("waves-effect waves-light btn green"),
                ru(yu)
            ]), $([
                A2(eu, "home", "left"),
                Mi("home")
            ])),
            to(n)
        ]), Yu, A2(Hi, "error", $([
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        A2(eo, g, $([
                            Mi("Error")
                        ])),
                        A2(bu, g, (t = e, A2(Jt, function(e) {
                            return A2(cu, g, $([
                                Mi(e)
                            ]));
                        }, t)))
                    ]))
                ]))
            ]))
        ])));
    }), ao = F2(function(e, n) {
        return {
            $: 8,
            a: e,
            b: n
        };
    }), io = F3(function(e, n, t) {
        return {
            $: 7,
            a: e,
            b: n,
            c: t
        };
    }), uo = F5(function(e, n, t, r) {
        return h($([
            A2(Ui, $([
                Fi("waves-effect waves-light btn green"),
                ru(yu)
            ]), $([
                A2(eu, "home", "left"),
                Mi("back")
            ]))
        ]), A2(Ji, e, $([
            Mi("Joining game")
        ])), A2(Hi, "join", $([
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        Ru(A2(Su, $([
                            "game code",
                            "screen name"
                        ]), r)),
                        A2(_u, $([
                            Ou(A2(ao, n, t))
                        ]), $([
                            A5(Mu, "Game code", "game-code", n, A2(xu, "game code", r), $([
                                Cu(function(e) {
                                    return A3(io, e, t, A2(ku, "game code", r));
                                })
                            ])),
                            A5(Mu, "Player name", "player-name", t, A2(xu, "screen name", r), $([
                                Cu(function(e) {
                                    return A3(io, n, e, A2(ku, "screen name", r));
                                })
                            ])),
                            A2(Ui, $([
                                Fi("waves-effect waves-light cyan btn btn-large")
                            ]), $([
                                Mi("Join game"),
                                A2(eu, "person_add", "right")
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        Vi("|Join an existing game and set your player name.\n                           |The game's creator can tell you the game code.\n                           |")
                    ]))
                ]))
            ]))
        ])));
    }), oo = F2(function(e) {
        return h(g, A2(Ji, !0, $([
            Mi(e)
        ])), Wi);
    }), co = F2(function(e, n) {
        return {
            $: 28,
            a: e,
            b: n
        };
    }), so = F4(function(e, n, t) {
        return h($([
            A2(Ui, $([
                Fi("waves-effect waves-light blue btn-flat"),
                ru(no)
            ]), $([
                A2(eu, "close", "left"),
                Mi("cancel")
            ]))
        ]), A2(Ji, t, $([
            Mi("Finishing pitch")
        ])), A2(Hi, "pitching", $([
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        A2(Ki, $([
                            Fi("pitch__container")
                        ]), $([
                            A2(gu, $([
                                Fi("pitch--word")
                            ]), $([
                                Mi(e)
                            ])),
                            Mi(" "),
                            A2(gu, $([
                                Fi("pitch__divider grey-text text-lighten-1")
                            ]), $([
                                Mi(" ")
                            ])),
                            Mi(" "),
                            A2(gu, $([
                                Fi("pitch--word")
                            ]), $([
                                Mi(n)
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "m6 s12 push-m6", $([
                    Bi($([
                        A2(Ui, $([
                            Fi("waves-effect waves-light btn btn-large blue cta__button"),
                            ru(A2(co, e, n))
                        ]), $([
                            Mi("Finish pitch"),
                            A2(eu, "done", "right")
                        ]))
                    ]))
                ]))
            ]))
        ])));
    }), fo = F2(function(e) {
        return h(g, A2(Ji, !0, $([
            A2(lu, g, $([
                Mi("Re-joining "),
                Mi(e.at)
            ]))
        ])), A2(Hi, "rejoining", g));
    }), lo = {
        $: 17
    }, ho = F2(function(e, n) {
        return {
            $: 27,
            a: e,
            b: n
        };
    }), bo = F2(function(e, n) {
        return {
            $: 15,
            a: e,
            b: n
        };
    }), po = F2(function(e, n) {
        return A2(Ki, $([
            Fi("hand__card")
        ]), $([
            A2(Ui, $([
                Ju($([
                    l("waves-effect waves-light btn bt-flat blue cta__button", !0),
                    l("word--selected", A2(Au, n, e))
                ])),
                ru(A2(bo, n, e)),
                ou(A2(Au, n, e))
            ]), $([
                Mi(n)
            ]))
        ]));
    }), go = F2(function(e, n) {
        return 1 === n ? e : e + "s";
    }), vo = F2(function(e, n) {
        var t = Gn(n.bb);
        return A2(cu, $([
            Fi("collection-item")
        ]), $([
            A2(Ki, g, $([
                Mi(n.ac),
                A2(gu, $([
                    Ju($([
                        l("badge", !0),
                        l("amber black-text", i(e, t) && t > 0)
                    ])),
                    A2(Xu, "data-badge-caption", A2(go, "point", Gn(n.bb)))
                ]), $([
                    Mi(Jn(t))
                ]))
            ]))
        ]));
    }), mo = F2(function(e, n) {
        return {
            $: 16,
            a: e,
            b: n
        };
    }), $o = F2(function(e, n) {
        return A2(Ki, $([
            Fi("container--spaced")
        ]), $([
            A2(Ui, $([
                Fi("waves-effect waves-light btn btn-large cta__button blue"),
                ru(A2(mo, n, e))
            ]), $([
                Mi(n),
                A2(eu, "backspace", "right")
            ]))
        ]));
    }), yo = A2(Ki, $([
        Fi("container--spaced")
    ]), $([
        A2(Ui, $([
            Fi("waves-effect waves-light btn btn-large cta__button blue disabled"),
            ou(!0)
        ]), $([
            Mi("Select word")
        ]))
    ])), wo = function(e) {
        if (e.b) {
            if (e.b.b) {
                if (e.b.b.b) return A2(lu, $([
                    Fi("error")
                ]), $([
                    Mi("Too many words selected")
                ]));
                var n = e.b.a;
                return A2(Ki, g, $([
                    A2($o, e, e.a),
                    A2($o, e, n)
                ]));
            }
            return A2(Ki, g, $([
                A2($o, e, e.a),
                yo
            ]));
        }
        return A2(Ki, g, $([
            yo,
            yo
        ]));
    }, ko = F3(function(e, n, t) {
        var r, a = A2(Ni, g, A2(Ai, function(e) {
            return e.bb;
        }, t.cz)), u = Gn(a), o = A2(mt, u, A2(Ni, 0, (r = A2(Jt, A2(wu, function(e) {
            return e.bb;
        }, Gn), t.ck)).b ? Pn(A3(Bn, mt, r.a, r.b)) : Rn)), c = A2(Ni, g, A2(Ai, function(e) {
            return e.bX;
        }, t.cz));
        return h($([
            A2(Ui, $([
                Fi("waves-effect waves-light btn green"),
                ru(yu)
            ]), $([
                A2(eu, "home", "left"),
                Mi("Leave game")
            ]))
        ]), Yu, A2(Hi, "spectating", $([
            Ru(n),
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        Vi('|You can take a turn as the **buyer** (below) or choose 2 words\n                           |that together represent a product you will pitch to the buyer.\n                           |\n                           |When it is your turn to **pitch** select "Start pitch".\n                           |')
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    Bi($([
                        du($([
                            A2(Gi, "m6 s12", $([
                                A2(Ki, $([
                                    Fi("hand__container")
                                ]), A2(Jt, po(e), c))
                            ])),
                            A2(Gi, "m6 s12", $([
                                wo(e),
                                A2(Ki, $([
                                    Fi("container--spaced")
                                ]), $([
                                    A2(Ui, function() {
                                        if (e.b && e.b.b && !e.b.b.b) {
                                            var n = e.a, t = e.b.a;
                                            return $([
                                                Fi("waves-effect waves-light btn btn-large indigo cta__button"),
                                                ru(A2(ho, n, t)),
                                                ou(!1)
                                            ]);
                                        }
                                        return $([
                                            Fi("waves-effect waves-light btn btn-large indigo cta__button"),
                                            ou(!0)
                                        ]);
                                    }(), $([
                                        Mi("Start pitch"),
                                        A2(eu, "play_arrow", "right")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "m6 s12", $([
                    Bi($([
                        A2(Ui, $([
                            Fi("waves-effect waves-light btn purple cta__button"),
                            ru(lo)
                        ]), $([
                            Mi("Buyer"),
                            A2(eu, "play_arrow", "right")
                        ]))
                    ]))
                ]))
            ])),
            du($([
                A2(Gi, "s12", $([
                    A2(bu, $([
                        Fi("collection z-depth-1")
                    ]), d($([
                        A2(cu, $([
                            Fi("collection-item")
                        ]), $([
                            A2(Ki, g, $([
                                Mi("You"),
                                A2(gu, $([
                                    Ju($([
                                        l("badge", !0),
                                        l("new amber black-text", i(o, u) && u > 0)
                                    ])),
                                    A2(Xu, "data-badge-caption", A2(go, "point", Gn(a)))
                                ]), $([
                                    Mi(Jn(u))
                                ]))
                            ]))
                        ]))
                    ]), A2(Jt, vo(o), t.ck)))
                ]))
            ]))
        ])));
    }), xo = qe("strong"), _o = function(e) {
        return {
            $: 11,
            a: e
        };
    }, jo = qe("em"), zo = w, Ao = F2(function(e, n) {
        var t, r = e - n.cx, a = A2(zo, 24, gt(r / 1e3 / 60 / 60)), i = A2(zo, 60, gt(r / 1e3 / 60)), u = gt(r / 1e3 / 60 / 60 / 24), o = 1 > i ? "Just now" : 1 === i ? "1 minute ago" : 1 > a ? Jn(i) + " minutes ago" : 1 === a ? "1 hour ago" : 1 > u ? Jn(a) + " hours ago" : 1 === u ? "yesterday" : Jn(u) + " days ago";
        return A2(Gi, "s12 m6", $([
            Bi($([
                A2(Ui, $([
                    Fi("rejoin--close waves-effect waves-light btn btn-floating brown right"),
                    ru((t = n, {
                        $: 12,
                        a: t
                    }))
                ]), $([
                    A2(eu, "close", "right")
                ])),
                A2(Ki, $([
                    Fi("valign-wrapper")
                ]), $([
                    A2(eu, "access_time", "left"),
                    A2(Ki, $([
                        Fi("rejoin-game__ago-text grey-text")
                    ]), $([
                        A2(jo, g, $([
                            Mi(o)
                        ]))
                    ]))
                ])),
                A2(lu, $([
                    Fi("rejoin-game__game-name valign-wrapper")
                ]), $([
                    A2(eu, "gamepad", "left"),
                    A2(xo, g, $([
                        Mi(n.at)
                    ]))
                ])),
                A2(lu, $([
                    Fi("rejoin-screen-name valign-wrapper")
                ]), $([
                    A2(eu, "person", "left"),
                    Mi(n.ac)
                ])),
                A2(Ui, $([
                    Fi("waves-effect waves-light btn btn-large cyan cta__button"),
                    ru(_o(n))
                ]), $([
                    Mi("Rejoin"),
                    A2(eu, "group_add", "right")
                ]))
            ]))
        ]));
    }), So = F2(function(e, n) {
        return au(n) ? Wi : du(A2(Jt, Ao(e), n));
    }), To = du($([
        A2(Gi, "s12", $([
            Bi($([
                A2(lu, g, $([
                    Mi("Quack Stanley is a party game for 3+ players that rewards quick thinking, wit and comedy.")
                ])),
                A2(lu, g, $([
                    Mi("How to play:")
                ])),
                Vi("|One player chooses to become the **buyer**, and is given a **role**.\n                       |\n                       |Each of the other players chooses 2 words from their hand\n                       |that together represent a **product** they think the buyer would like.\n                       |\n                       |One at a time, they use those words to **pitch** their\n                       |product to the buyer.\n                       |\n                       |After each player has pitched their product the buyer chooses their\n                       |favourite pitch. This player wins the round and receives 1 point.\n                       |\n                       |Now another player can have a turn as the buyer and the same\n                       |thing happens again.\n                       |\n                       |The game keeps going for as long as you are all enjoying yourselves.\n                       |"),
                A2(lu, g, $([
                    Mi("Top tips:")
                ])),
                Vi("|Consider the buyer's role when you choose and pitch your\n                       |product.\n                       |\n                       |**Example:** If the buyer is an *Astronaut* and your\n                       |hand contains *Hoodie*, *Velcro*, *Barricade*, *Pyjamas*,\n                       |*Oven* and *Cone* you might choose *Velcro* and *Pyjamas*.\n                       |You could pitch *Velcro Pyjamas* to the buyer by talking about\n                       |how hard it is to get a good night's sleep when you're floating\n                       |in space. Be creative!\n                       |")
            ]))
        ]))
    ])), Lo = F3(function(e, n, t) {
        return h(g, A2(Ji, !t, $([
            Mi("Loading")
        ])), A2(Hi, "welcome", $([
            A2(So, e, n),
            du($([
                A2(Gi, "s12 m6 center-align", $([
                    Bi($([
                        A2(Ui, $([
                            Fi("waves-effect waves-light btn btn-large teal cta__button"),
                            ru(A3($u, "", "", g))
                        ]), $([
                            Mi("Create game"),
                            A2(eu, "gamepad", "right")
                        ]))
                    ]))
                ])),
                A2(Gi, "s12 m6 center-align", $([
                    Bi($([
                        A2(Ui, $([
                            Fi("waves-effect waves-light btn btn-large cyan cta__button"),
                            ru(A3(io, "", "", g))
                        ]), $([
                            Mi("Join game"),
                            A2(eu, "person_add", "right")
                        ]))
                    ]))
                ]))
            ])),
            To
        ])));
    }), No = qe("footer"), Co = qe("header"), Eo = function(e) {
        return A2(Re, "height", Jn(e));
    }, qo = qe("img"), Oo = qe("main"), Io = qe("nav"), Po = F2(function(e, n) {
        return A2(Ki, $([
            Ju($([
                l("shroud", !0),
                l("hidden", !n)
            ]))
        ]), $([
            A2(Ki, $([
                Ju($([
                    l("message-box__container", !0),
                    l("hidden", !n)
                ]))
            ]), $([
                A2(Ki, $([
                    Fi("message-box")
                ]), e)
            ]))
        ]));
    }), Ro = function(e) {
        switch(e.$){
            case 0:
                var n = e.b;
                return A2(Po, (t = e.a) ? n : $([
                    Wi
                ]), t);
            case 1:
                var t;
                return n = e.b, A2(Po, (t = e.a) ? n : $([
                    Wi
                ]), t);
            default:
                return A2(Po, $([
                    Wi
                ]), !1);
        }
    };
    !function(n) {
        e.Elm ? Le(e.Elm, n) : e.Elm = n;
    }({
        Main: {
            init: Qt({
                b$: function(e) {
                    var n = {
                        w: e.w,
                        bA: !1,
                        b0: !1,
                        b4: Zt,
                        ck: g,
                        cm: Rn,
                        ct: Rn,
                        cv: g,
                        ao: e.ao,
                        cz: Rn,
                        cE: 0
                    };
                    return l(n, nr($([
                        ra(n),
                        A2(Yt, er, rr),
                        tr(0)
                    ])));
                },
                cB: function(e) {
                    switch(e.b4.$){
                        case 0:
                            return oa($([
                                _a(aa),
                                A2(ka, 6e4, er)
                            ]));
                        case 4:
                        case 12:
                            return A2(ka, 5e3, ua);
                        case 2:
                            return A2(ka, 5e3, ia);
                        case 7:
                            return A2(ka, 15e3, ua);
                        default:
                            return xa;
                    }
                },
                cH: Ii,
                cI: function(e) {
                    var n, t, r = function(e) {
                        switch(e.$){
                            case 0:
                                return "green";
                            case 1:
                            case 2:
                                return "teal";
                            case 3:
                            case 4:
                            case 5:
                                return "cyan";
                            case 6:
                            case 7:
                            case 11:
                                return "blue";
                            case 8:
                                return e.c ? "blue" : "indigo";
                            case 9:
                            case 10:
                            case 12:
                            case 13:
                                return "purple";
                            default:
                                return "red";
                        }
                    }(e.b4), a = function(e) {
                        var n = e.b4;
                        switch(n.$){
                            case 0:
                                return function(e) {
                                    return A3(Lo, e.cE, e.cv, e.bA);
                                }(e);
                            case 1:
                                var t = n.a;
                                return A5(Wu, t.a2, t.at, t.ac, t.aP, e);
                            case 3:
                                var r = n.a;
                                return A5(uo, r.a2, r.aT, r.ac, r.aP, e);
                            case 4:
                                return function(e) {
                                    var n = A2(Ni, "Your name was not found", A2(Ai, function(e) {
                                        return e.ac;
                                    }, e.cz)), t = A2(Ni, "Game name not found", A2(Ai, function(e) {
                                        return e.at;
                                    }, e.cz));
                                    return h(g, Yu, A2(Hi, "waiting", $([
                                        du($([
                                            A2(Gi, "s12 m6", $([
                                                Bi($([
                                                    A2(lu, $([
                                                        Fi("card-header valign-wrapper")
                                                    ]), $([
                                                        A2(eu, "gamepad", "left"),
                                                        A2(xo, g, $([
                                                            Mi(t)
                                                        ]))
                                                    ])),
                                                    A2(lu, $([
                                                        Fi("valign-wrapper")
                                                    ]), $([
                                                        A2(eu, "person", "left"),
                                                        Mi(n)
                                                    ])),
                                                    A2(lu, $([
                                                        Fi("flow-text")
                                                    ]), $([
                                                        Mi("Waiting for the game to start")
                                                    ]))
                                                ]))
                                            ])),
                                            A2(Gi, "s12 m6", $([
                                                Bi($([
                                                    Vi("When all players have joined the creator can start the game.")
                                                ]))
                                            ]))
                                        ]))
                                    ])));
                                }(e);
                            case 5:
                                return A2(fo, n.a, e);
                            case 2:
                                return A3(Zu, n.a, n.b, e);
                            case 6:
                                return A2(oo, "Starting game", e);
                            case 7:
                                return A3(ko, n.a, n.b, e);
                            case 8:
                                return A4(so, n.a, n.b, n.c, e);
                            case 10:
                                return A2(oo, "Loading role", e);
                            case 12:
                                return A3(vu, n.a, Rn, e);
                            case 11:
                                return A2(oo, "Returning to game", e);
                            case 13:
                                return A3(vu, n.a, Pn(n.b), e);
                            case 14:
                                return A2(ro, n.a, e);
                            default:
                                return A2(ro, $([
                                    "Unknown application state"
                                ]), e);
                        }
                    }(e), i = a.a, u = a.b, o = a.c;
                    return A2(Ki, $([
                        Uu("app-root")
                    ]), $([
                        A2(Co, g, $([
                            A2(Io, $([
                                Fi(r)
                            ]), $([
                                A2(Ki, $([
                                    Fi("nav-wrapper container")
                                ]), $([
                                    A2(Pi, $([
                                        Uu("logo-container"),
                                        Fi(r)
                                    ]), $([
                                        A2(qo, $([
                                            (t = e.ao, A2(Ri, "src", Je(t))),
                                            Xi("Quack Stanley"),
                                            A2(Re, "width", Jn(80)),
                                            Eo(80)
                                        ]), g)
                                    ]))
                                ]))
                            ]))
                        ])),
                        (n = i, A2(Ki, $([
                            Fi("game-nav")
                        ]), $([
                            A2(Hi, "", $([
                                du($([
                                    A2(Gi, "s12", n)
                                ]))
                            ]))
                        ]))),
                        Ro(u),
                        A2(Oo, g, $([
                            o
                        ])),
                        A2(No, $([
                            Fi("page-footer")
                        ]), $([
                            A2(Ki, $([
                                Fi("footer-color " + r)
                            ]), g)
                        ]))
                    ]));
                }
            })(A2(St, function(e) {
                return A2(St, function(n) {
                    return Nt({
                        w: n,
                        ao: e
                    });
                }, A2(Vt, "apiRoot", vr));
            }, A2(Vt, "stanleyLogoUrl", vr)))(0)
        }
    });
}($a0b4f895e1596b3b$exports);


var $81ba0836733ca2ef$exports = {};
$81ba0836733ca2ef$exports = $parcel$resolve("hhnHs");


const $35da740d59af89ba$var$stanleyLogoUrl = new URL($81ba0836733ca2ef$exports);
var $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById('root'),
    flags: {
        apiRoot: $35da740d59af89ba$var$deriveApiRoot(document.location),
        stanleyLogoUrl: $35da740d59af89ba$var$stanleyLogoUrl.toString()
    }
});
// saved games, should be in own module!
var $35da740d59af89ba$var$savedGamesKey = "QS_SAVED_GAMES";
$35da740d59af89ba$var$app.ports.fetchSavedGames.subscribe(function() {
    var existingGames = JSON.parse(localStorage.getItem($35da740d59af89ba$var$savedGamesKey)) || [];
    // clear out expired games
    var recentGames = $35da740d59af89ba$var$filterExpired(existingGames);
    localStorage.setItem($35da740d59af89ba$var$savedGamesKey, JSON.stringify(recentGames));
    $35da740d59af89ba$var$app.ports.savedGames.send(recentGames);
});
$35da740d59af89ba$var$app.ports.sendGameToJS.subscribe(function(game) {
    var now = +new Date;
    game.startTime = now;
    var games = JSON.parse(localStorage.getItem($35da740d59af89ba$var$savedGamesKey)) || [];
    // remove matching games before saving to deduplicate
    var filteredGames = $35da740d59af89ba$var$removeGame(games, game);
    filteredGames.unshift(game);
    localStorage.setItem($35da740d59af89ba$var$savedGamesKey, JSON.stringify(filteredGames));
});
$35da740d59af89ba$var$app.ports.removeSavedGame.subscribe(function(game) {
    var existingGames = JSON.parse(localStorage.getItem($35da740d59af89ba$var$savedGamesKey)) || [];
    // clear out expired games
    var filteredGames = $35da740d59af89ba$var$removeGame(existingGames, game);
    localStorage.setItem($35da740d59af89ba$var$savedGamesKey, JSON.stringify(filteredGames));
    $35da740d59af89ba$var$app.ports.savedGames.send(filteredGames);
});
function $35da740d59af89ba$var$filterExpired(games) {
    var now = +new Date;
    var maxAge = 345600000; // 4 days
    return games.filter(function(game) {
        return game.startTime > now - maxAge;
    });
}
function $35da740d59af89ba$var$removeGame(games, game) {
    return games.filter(function(savedGame) {
        var match = savedGame.gameId == game.gameId && savedGame.playerKey == game.playerKey;
        return !match;
    });
}
function $35da740d59af89ba$var$deriveApiRoot(location) {
    var devHost = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/;
    if (location.hostname === "localhost" || devHost.test(location.hostname)) return location.protocol + "//" + location.hostname + ":9001/api";
    else return location.protocol + "//api." + location.hostname + "/";
}


//# sourceMappingURL=frontend.dd8d79a7.js.map
